<template v-bind:style="{position}">
  <nav id="nav">
    <router-link   id="one" to="/">Home</router-link>&nbsp;&nbsp;
    <router-link  id="two"   to="/trading">Trading</router-link>&nbsp;&nbsp;
    <router-link   id="three" to="/logistics">Logistics</router-link>&nbsp;&nbsp;
    <router-link    id="four" to="/team">Team</router-link>&nbsp;&nbsp;
    <router-link    id="five" to="/philantropy">Philantropy</router-link>&nbsp;&nbsp;
    <router-link   id="six" to="/contact">Contact</router-link>&nbsp;

  </nav>
  <nav v-if="!show" id="nav1">
    <router-link   id="one" to="/">Home</router-link>&nbsp;&nbsp;
    <router-link  id="two"   to="/trading">Trading</router-link>&nbsp;&nbsp;
    <router-link   id="three" to="/logistics">Logistics</router-link>&nbsp;&nbsp;
    <router-link    id="four" to="/team">Team</router-link>&nbsp;&nbsp;
    <router-link    id="five" to="/philantropy">Philantropy</router-link>&nbsp;&nbsp;
    <router-link   id="six" to="/contact">Contact</router-link>&nbsp;

  </nav>
  <router-view/>
  
 
    <img id="front1" v-if="show" src="mountainpic.webp" />
    




    
    <button id="buton334" v-if="!day" @click="show = !show;handleClick();" :style="{backgroundColor: active ? 'transparent' : 'transparent',color: active ? '#0D6EFD':'white',}"><i class="fa-solid fa-bars"></i></button>
    <button id="buton335" v-if="show" @click="show = !show;handleClick();" :style="{backgroundColor: active ? '#0D6EFD' : 'white',color: active ? 'white':'#0D6EFD',}"> click </button>
    <text style="display:none;  " v-if="show" id="click"> to begin </text>
   
    <text id="registered"> Ardeat Trade. All rights reserved &#174; </text>
    <text id="registered1"> Ardeat Trade. All rights reserved &#174; </text>
    <text id="registered2"> Ardeat Trade. All rights reserved &#174; </text>
    <text  id="moto"> <span id="prof" style="color:#30D5C8"> Professional </span> &nbsp;trading since 2008.  </text>
    <text v-if="show" style="font-weight:lighter" v-html="$t('moto')" id="citat"> </text>
    <text v-if="show" style="font-weight:lighter" v-html="$t('moto')" id="citat1"> </text>
    <text v-if="show" style="font-weight:lighter" v-html="$t('moto')" id="citat2"> </text>
   <div class="locale-changer">
    <text style="color:#2DE2D3" id="select">Language
    &nbsp;&nbsp;<select id="lang" v-model="$i18n.locale">
      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
        {{ lang }}
      </option>
    </select>
   
    </text> 
  </div>
  <div class="locale-changer1">
    <text style="color:#2DE2D3"  id="select1">{{ $t('langg') }}
    &nbsp;&nbsp;<select id="lang1" v-model="$i18n.locale">
      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
        {{ lang }}
      </option>
    </select>
    </text> 
  </div>

<img  id="ardeat1" src="ardeat.webp" />
  <text id="pfooter"> Copyright &#169; 2008 Ardeat Trade  </text>
  <text @click="tips = !tips" id="privacy">Privacy policy</text>
  <text @click="tips1 = !tips1" id="terms">Terms and conditions</text> 
  <img id="ardeat" src="ardeat.webp" />  



 <div v-if="!tips" class="policy">
  <a @click="tips = !tips" class="closebtn">&times;</a>
  
  <span id="titlus">Privacy Policy</span><br>
  <div id="textup">
Last updated: May 28, 2023<br>
This Privacy Policy describes our policies and procedures on the collection, use and disclosure of your information when you use the service and tells you about your privacy rights and how the law protects you.
We use your personal data to provide and improve the service. By using the service, you agree to the collection and use of information in accordance with this Privacy Policy.<br>
<span id="span23">Interpretation and Definitions</span><br>
<span id="span19">Interpretation</span><br>
The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
<br>
<span id="span19">Definitions</span> <br>
For the purposes of this Privacy Policy: <br>
<b>Account</b> means a unique account created for You to access our service or parts of our service.<br>
<b>Affiliate</b> means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.<br>
<b>Company</b> (referred to as either "the Company", "we", "us" or "our" in this Agreement) refers to Ardeat Trade SRL, str.Ion Georgescu 4A Arad,Romania .<br>
<b>Cookies</b> are small files that are placed on your computer, mobile device or any other device by a website, containing the details of your browsing history on that website among its many uses.<br>
<b>Country</b> refers to: Romania <br>
<b>Device</b> means any device that can access the service such as a computer, a cellphone or a digital tablet.<br>
<b>Personal Data </b> is any information that relates to an identified or identifiable individual.<br>
<b>Service</b> refers to the website.<br>
  <b>Service</b> provider means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the service, to provide the service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.<br>
<b>Usage Data</b> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).<br>
<b>Website</b> refers to Ardeat, accessible from http://www.ardeat.com <br>
<b> You</b> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.<br>
 <span id="span23">Collecting and using your personal data </span> <br>
<span id="span19">Types of data collected</span> <br>
<span style="color:cadetblue"> Personal data </span><br>
While using our service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to: <br>
<span style="color:cadetblue"> Usage Data </span><br>
<b>Usage Data</b> is collected automatically when using the service.<br>
<b>Usage Data</b> may include information such as your device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.<br>
When you access the service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.<br>
We may also collect information that your browser sends whenever you visit our service or when you access the service by or through a mobile device.<br>
<span style="color:cadetblue">Tracking Technologies and Cookies</span><br>
We use Cookies and similar tracking technologies to track the activity on our Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service. The technologies we use may include: <br>
<b>Cookies or Browser Cookies</b>. A cookie is a small file placed on your device. You can instruct your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if you do not accept Cookies, you may not be able to use some parts of our service. Unless you have adjusted your browser setting so that it will refuse Cookies, our Service may use Cookies.<br>
<b>Web Beacons</b>. Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a certain section and verifying system and server integrity).<br>
Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on your personal computer or mobile device when you go offline, while session Cookies are deleted as soon as you close your web browser. You can learn more about cookies on TermsFeed website article.<br>
We use both Session and Persistent Cookies for the purposes set out below:<br>
<b>Necessary / Essential Cookies</b> <br>
Type: Session Cookies <br>
Administered by: Us <br>
Purpose: These Cookies are essential to provide you with services available through the website and to enable you to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that you have asked for cannot be provided, and we only use these Cookies to provide you with those services.<br>
<b>Cookies Policy / Notice Acceptance Cookies </b> <br>
Type: Persistent Cookies <br>
Administered by: Us <br>
Purpose: These cookies identify if users have accepted the use of cookies on the website. <br>
Functionality Cookies <br>
Type: Persistent Cookies <br>
Administered by: Us <br>
Purpose: These Cookies allow us to remember choices you make when you use the Website, such as remembering your login details or language preference.<br>
The purpose of these Cookies is to provide you with a more personal experience and to avoid you having to re-enter your preferences every time you use the website.<br>
For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the Cookies section of our Privacy Policy.<br>
<span style="color:cadetblue">Use of Your Personal Data</span> <br>
The Company may use Personal Data for the following purposes: <br>
<b>To provide and maintain our Service</b>, including to monitor the usage of our Service.<br>
<b>To manage Your Account</b>: to manage your registration as a user of the Service. The Personal data you provide can give you access to different functionalities of the Service that are available to you as a registered user.<br>
<b>For the performance of a contract</b>: the development, compliance and undertaking of the purchase contract for the products, items or services you have purchased or of any other contract with us through the Service.<br>
<b>To contact you</b>: To contact you by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.<br>
<b>To provide you with news</b>, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information.<br>
<b>To manage your requests</b>: To attend and manage your requests to us.<br>
<b>For business transfers</b>: We may use your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which personal data held by us about our Service users is among the assets transferred.<br>
<b>For other purposes</b>: We may use your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.<br>
We may share your personal information in the following situations:<br>
<b>With Service Providers</b>: We may share your personal information with Service providers to monitor and analyze the use of our Service, to contact you.<br>
<b>For business transfers</b>: We may share or transfer your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of our business to another company.<br>
<b>With Affiliates</b>: We may share your information with our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with us.<br>
<b>With business partners</b>: We may share your information with our business partners to offer you certain products, services or promotions.<br>
<b>With other users</b>: when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.<br>
<b>With your consent</b>: We may disclose your personal information for any other purpose with your consent.<br>
<span id="span19">Retention of Your Personal Data</span> <br>
The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.<br>
The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.<br>
<span id="span19">Transfer of Your Personal Data</span><br>
Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.<br>
Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.<br>
The Company will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.<br>
<span id="span19">Delete Your Personal Data</span><br>
You have the right to delete or request that we assist in deleting the Personal Data that we have collected about you.<br>
Our Service may give you the ability to delete certain information about you from within the Service.<br>
You may update, amend, or delete your information at any time by signing in to your account, if you have one, and visiting the account settings section that allows you to manage your personal information. You may also contact us to request access to, correct, or delete any personal information that you have provided to us.<br>
Please note, however, that we may need to retain certain information when we have a legal obligation or lawful basis to do so.<br>
<span id="span19">Disclosure of your Personal Data</span><br>
<span style="color:cadetblue">Business Transactions</span> <br>
If the company is involved in a merger, acquisition or asset sale, your personal data may be transferred. We will provide notice before your personal data is transferred and becomes subject to a different Privacy Policy.<br>
<span style="color:cadetblue">Law enforcement</span> <br>
Under certain circumstances, the company may be required to disclose your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).<br>
<span style="color:cadetblue">Other legal requirements</span><br>
The Company may disclose your personal data in the good faith belief that such action is necessary to:<br>
Comply with a legal obligation<br>
Protect and defend the rights or property of the Company<br>
Prevent or investigate possible wrongdoing in connection with the Service<br>
Protect the personal safety of Users of the Service or the public<br>
Protect against legal liability<br>
<span id="span19">Security of Your Personal Data</span><br>
The security of your Personal Data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.<br>
<span id="span23">Children's Privacy</span><br>
Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and you are aware that your child has provided us with personal data, please contact us. If we become aware that we have collected personal data from anyone under the age of 13 without verification of parental consent, we take steps to remove that information from our servers.<br>
If we need to rely on consent as a legal basis for processing your information and your country requires consent from a parent, we may require your parent's consent before We collect and use that information.<br>
<span id="span23">Links to Other Websites</span><br>
Our service may contain links to other websites that are not operated by us. If You click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.<br>
We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.<br>
<span id="span23">Changes to this Privacy Policy</span><br>
We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.<br>
We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.<br>
You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.<br>
<span id="span23">Contact Us</span><br>
If you have any questions about this Privacy Policy, you can contact us:<br>
By email: office@ardeat.com
<div id="butonup">
<br><br><button @click="tips = !tips" class="clozebtn">Close</button>
</div>
  </div>
</div>
<div v-if="!tips1" class="terms">
<a @click="tips1 = !tips1" class="closebtn">&times;</a>
<span id="titlus">Acknowledgement</span><br>
<div id="textup">
These are the Terms and Conditions governing the use of this Service and the agreement that operates between You and the Company. These Terms and Conditions set out the rights and obligations of all users regarding the use of the Service.<br>
Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms and Conditions. These Terms and Conditions apply to all visitors, users and others who access or use the Service.<br>
By accessing or using the Service you agree to be bound by these Terms and Conditions. If you disagree with any part of these Terms and Conditions then you may not access the Service.<br>
Your access to and use of the Service is also conditioned on your acceptance of and compliance with the Privacy Policy of the Company. Our Privacy Policy describes our policies and procedures on the collection, use and disclosure of your personal information when you use the application or the website and tells you about your privacy rights and how the law protects you. Please read our Privacy Policy carefully before using Our Service.<br>
<span id="span23">Links to Other Websites</span><br>
Our Service may contain links to third-party web sites or services that are not owned or controlled by the Company.<br>
The Company has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that the Company shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods or services available on or through any such web sites or services.<br>
We strongly advise you to read the terms and conditions and privacy policies of any third-party web sites or services that you visit.
<br><span id="span23">Termination</span><br>
We may terminate or suspend your access immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach these Terms and Conditions.<br>
Upon termination, your right to use the Service will cease immediately.<br>
<span id="span23">Limitation of Liability</span><br>
Notwithstanding any damages that you might incur, the entire liability of the Company and any of its suppliers under any provision of this Terms and your exclusive remedy for all of the foregoing shall be limited to the amount actually paid by you through the Service or 100 USD if you haven't purchased anything through the Service.<br>
To the maximum extent permitted by applicable law, in no event shall the Company or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever (including, but not limited to, damages for loss of profits, loss of data or other information, for business interruption, for personal injury, loss of privacy arising out of or in any way related to the use of or inability to use the Service, third-party software and/or third-party hardware used with the Service, or otherwise in connection with any provision of this Terms), even if the Company or any supplier has been advised of the possibility of such damages and even if the remedy fails of its essential purpose.<br>
Some states do not allow the exclusion of implied warranties or limitation of liability for incidental or consequential damages, which means that some of the above limitations may not apply. In these states, each party's liability will be limited to the greatest extent permitted by law.<br>
<span id="span23">"AS IS" and "AS AVAILABLE" Disclaimer</span><br>
The Service is provided to You "AS IS" and "AS AVAILABLE" and with all faults and defects without warranty of any kind. To the maximum extent permitted under applicable law, the Company, on its own behalf and on behalf of its affiliates and its and their respective licensors and service providers, expressly disclaims all warranties, whether express, implied, statutory or otherwise, with respect to the Service, including all implied warranties of merchantability, fitness for a particular purpose, title and non-infringement, and warranties that may arise out of course of dealing, course of performance, usage or trade practice. Without limitation to the foregoing, the Company provides no warranty or undertaking, and makes no representation of any kind that the Service will meet your requirements, achieve any intended results, be compatible or work with any other software, applications, systems or services, operate without interruption, meet any performance or reliability standards or be error free or that any errors or defects can or will be corrected.<br>
Without limiting the foregoing, neither the Company nor any of the company's provider makes any representation or warranty of any kind, express or implied: (I) as to the operation or availability of the Service, or the information, content, and materials or products included thereon; (II) that the Service will be uninterrupted or error-free; (III) as to the accuracy, reliability, or currency of any information or content provided through the Service; or (IV) that the Service, its servers, the content, or e-mails sent from or on behalf of the Company are free of viruses, scripts, trojan horses, worms, malware, timebombs or other harmful components.<br>
Some jurisdictions do not allow the exclusion of certain types of warranties or limitations on applicable statutory rights of a consumer, so some or all of the above exclusions and limitations may not apply to you. But in such a case the exclusions and limitations set forth in this section shall be applied to the greatest extent enforceable under applicable law.<br>
<span id="span23">Governing Law</span><br>
The laws of the Country, excluding its conflicts of law rules, shall govern this Terms and Your use of the Service. Your use of the application may also be subject to other local, state, national, or international laws.<br>
<span id="span23">Disputes Resolution</span><br>
If You have any concern or dispute about the Service, you agree to first try to resolve the dispute informally by contacting the Company.<br>
<span id="span23">For European Union (EU) Users</span><br>
If You are a European Union consumer, you will benefit from any mandatory provisions of the law of the country in which you are resident in.<br>
<span id="span23">United States Legal Compliance</span><br>
You represent and warrant that (I) You are not located in a country that is subject to the United States government embargo, or that has been designated by the United States government as a "terrorist supporting" country, and (II) You are not listed on any United States government list of prohibited or restricted parties.<br>
<span id="span23">Severability and Waiver</span><br>
<span style="color:cadetblue">Severability</span><br>
If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law and the remaining provisions will continue in full force and effect.<br>
<span style="color:cadetblue">Waiver</span><br>
Except as provided herein, the failure to exercise a right or to require performance of an obligation under these Terms shall not effect a party's ability to exercise such right or require such performance at any time thereafter nor shall the waiver of a breach constitute a waiver of any subsequent breach.<br>
<span id="span23">Translation Interpretation</span><br>
These Terms and Conditions may have been translated if we have made them available to you on our Service. You agree that the original English text shall prevail in the case of a dispute.<br>
<span id="span23">Changes to These Terms and Conditions</span><br>
We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will make reasonable efforts to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.<br>
By continuing to access or use Our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, in whole or in part, please stop using the website and the Service.<br>
<span id="span23">Contact Us</span><br>
If you have any questions about these Terms and Conditions, you can contact us:<br>
By email: <span style="color:cadetblue">office@ardeat.com</span><br>
By phone number: <span style="color:cadetblue">+40 721 274 184</span><br>
<br><br><button @click="tips1 = !tips1" class="clozebtn">Agree</button>
  </div>
</div>
  <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</template>
<script>
export default {
  data:function() {
    
    return {
      show:true, 
      space: " ",
      awesome: true,
      tips:true,
      tips1:true,
     langs: ['en', 'ro'] 
    };
  },
  methods: {
    handleClick() {
      this.active = !this.active;
    },
    handleClicking() {
      this.active = !this.active;
    }
  },
};

</script>

<style>


#app {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #e8e8e8;
}
#nav1 {
  display:none;
}
#titlus {
  font-size:32px;
  color:#31C6BB;
}
#span23 {
  font-size:23px;
  color:rgb(0, 208, 255);
}
#span19 {
  font-size:19px;
  color:cadetblue;
}
#citat1 {
  display:block;
  position:absolute;
left:0;
top:0;
margin-top:-2em;
 z-index:1;
}
html {
  background-color:grey;
}


#registered1 {
  display:block;
  position:absolute;
  left:0;
  top:0;
  margin-top:5.6em;
  margin-left:1.5em;
}
#registered {
  position:absolute;
  left:1.5%;
  top:10.5%;
  color:transparent;
}
#registered2 {
  display:none;
  position:absolute;
  left:1.5%;
  top:10.5%;
}
nav {
  padding: 30px;

}
a:visited { 
 text-decoration: none; 
  
}
nav a {
  position:relative;
  cursor:pointer;
  top:-.5em;
  left:3%;
  font-size:18px;
  background-color:transparent;
  border:0.2px solid white;
  border-radius: 2em;
  font-family: 'Poppins', sans-serif;
  color:#F1F2F2;
  width:10%;
  padding: 0.5em 1.8em;
  text-decoration:none;
  z-index:99 !important;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
}
nav a:hover {
  background-color:#343A40;
  color:white;
  transition:.4s ease-in-out;
}
.clozebtn {
  position:relative;
  padding:10px 10px;
  font-family: 'Poppins', sans-serif;
  font-size:12px;
  background-color:#343A40;
  color:white;
  border:.2px solid white;
  border-radius:5px;
  top:-2em;

}

#buton335 {
  display:none;
 background: #BEBEBE;
 border:1px solid transparent;
 border-radius: 2em;
 font: inherit;
 padding: 0.5em 1.8em;
 position:absolute;
 font-size:16.5px;
 left:6.5em;
 top:21.3em;
 color:white;
 z-index:1;
 box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
 display:none;
}
#buton335:hover {
  cursor:pointer;
}
#buton334 {
  display:none;
 border-radius:0.1em;
 font: inherit;
 height:12%;
 border:none;
 position:absolute;
 font-size:30px;
 color:white;
 z-index:1;
}
#buton334:hover {
  cursor:pointer;
}
.clozebtn:hover {
  background-color:grey;
  color:white;
  cursor:pointer;
  transition:0.4s ease-in-out;
}
nav a.router-link-exact-active {
 background:#0D6EFD;
color:white;
border:1px solid grey;
box-shadow:
    0 0 1px 1px #fff,
    0 0 1px 1px #7FFFB2,
    0 0 2px 4px #0D6EFD;

}
#gen {
 display:none;
}

 h2 {
 position:absolute;
 left:100%;
 color:white;
 font-size:24px;
 }
 
p {
 position:relative;
 left:-59em;
 top:-12.4em;
 color:white;
 
 text-align:center;
 font-size:12px;
 color:white;
}
#buton333 {
 background: #BEBEBE;
 border:1px solid transparent;
 border-radius: 2em;
 font: inherit;
 padding: 0.5em 1.2em;
 position:absolute;
 font-size:50.5px;
 left:0;
animation: enlarge 1.5s infinite;
 margin-top:-0.3em;
 margin-left:4.7em;
 color:transparent;
 z-index:1;
 box-shadow: transparent;
}
 #buton333:hover {
 background-color:#255661;
 cursor: pointer;
 transition:.7s ease-out;
 }
 #img1 {
 float:left;
 width:20%;
 height:51.70em; 
 position:absolute;
 left:0em;
}

#lang {
 position:absolute;
 z-index:99;
 outline:none;
 top:0em;
 display:none;
}
  #lang1 {
 position:absolute;
 z-index:99;
 top:-0.1em;
 font-family: 'Poppins', sans-serif;
  outline:none;
}
#textup {
  position:relative;
  top:4em;
}
.policy {
  z-index:1;
  width:50%;
  left:25%;
  opacity:0.9;
  position:absolute;
  background:rgb(30, 30, 30);
  height:70%;
  top:5.5em;
  overflow:scroll;
  border-radius:1em;
  padding:10px 10px 50px;
  font-family: 'Poppins', sans-serif;
}
.policy .closebtn {
  position: absolute;
  top:-.5%;
  left:1.5%;
  font-size: 40px; 
  text-decoration:none;
  cursor:pointer;
  width:1em;
  height:1em;
  border-radius:50%;
  color:rgb(149, 148, 148);
 
}
.closebtn:hover {
color:white;
}
.terms {
  z-index:1;
  width:50%;
  left:25%;
  opacity:0.9;
  position:absolute;
  background:rgb(30, 30, 30);
  height:70%;
  top:5.5em;
  overflow:scroll;
  border-radius:1em;
  padding:10px 10px 50px;
  font-family: 'Poppins', sans-serif;
}
.terms .closebtn {
  position: absolute;
  top:-.5%;
  left:1.5%;
  font-size: 40px; 
  text-decoration:none;
  cursor:pointer;
  width:1em;
  height:1em;
  border-radius:50%;
  color:rgb(149, 148, 148);
}
.closebtn:hover {
color:white;
}
#front1 {
 display:none;
 position:absolute;
 top:0em;
 width:100%;
 top:0px;
left:0px;
height:100%;
right:0px;
bottom:0px;
 filter:grayscale(80%);
}
.locale-changer {
 position:absolute;
 left:81%;
 top:3.5%;
 width:14em;
 display:none;
}
.locale-changer1 {
 position:absolute;
 right:0;
 top:0;
 margin-top:2.1em;
 margin-right:4em;
 width:14em;
 width:14em;
 
}

 #click {
 position:absolute;
 top:22.6em;
 font-size:16px;
 left:13em;
 color:#0D6EFD;
 display:none;
 }
 #click1 {
  position:absolute;
 left:0;
 top:0;
 margin-top:22.6em;
 margin-left:13.5em;
 color:#0D6EFD;
 }
#select {
  position:absolute;
  z-index:99;
  color:#2DE2D3;
  font-weight:bold;
  display:none;
}
#select1 {
  position:absolute;
  z-index:99;
  color:#2DE2D3;
  font-weight:bold;
}
#esc {
 position:relative;
 top:-40em;
 left:-18.9em;
 font-size:30px;
 z-index:99;
 color:#63E6BE;
}
#footer {
position:absolute;
height:285px;
width:100%;
bottom:-33.1%;
left:0em;
background-color:#343A40;
}
#ardeat {
 width:20.3em;
 height:6em;
 position:absolute;
 left:0;
 top:0;
 margin-top:0.5em;
 margin-left:0.4em;
 z-index:1;
}


#ardeat1 {
 position:absolute;
 bottom:0em;
 left:41%;
 z-index:1;
 height:80px;
 width:282px;
 
}
#citat {
 position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
#citat1 {
 position:absolute;
 top:15em;
 left:3.5em;
 z-index:1;
 font-size:22px;
}
#citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}

#footerb:hover {
 color:white;
 
}
#prof {
  font-weight:;
}
#pfooter {
 font-family: Avenir, Helvetica, Arial, sans-serif;
 position:absolute;
 bottom:0.5%;
 right:1em;
 color:white;
 opacity:0.2;
 font-size:13px;
}
#privacy {
  font-family: 'Poppins', sans-serif;
 position:absolute;
 bottom:0.5%;
 left:1em;
 color:white;
 opacity:0.8;
 font-size:16px;
}
#privacy:hover {
  color:#0D6EFD;
  cursor:pointer;
}
#terms {
  font-family: 'Poppins', sans-serif;
 position:absolute;
 bottom:0.5%;
 left:9em;
 color:white;
 opacity:0.6;
 font-size:16px;
}
#terms:hover {
  color:#0D6EFD;
  cursor:pointer;
}
#moto {
 position:absolute;
 color:#EBECF0;
 font-size:30.2px;
 width:18em;
 border-radius:1em;
 text-align:center;
left:0;
top:0;
margin-left:16em;
margin-top:2.2em;

}
#front {
 position:absolute;
 top:0em;
 width:100%;
 top:0px;
left:0px;
height:100%;
right:0px;
bottom:0px;
 filter:grayscale(80%);
}

@media (min-width:300px) and (max-width:429px) {
#nav {
  height:50px;
  display:none;
}
#nav1 {
  height:50px;
  display:block;
}
#app {
  height:10px;
}
  #front {
  display:none;
}
#front1 {
  display:block;
}s
.lds-ellipsis  {
  top:-10em;
}
.lds-ellipsis div:nth-child(1) {
  display:none;
}
.lds-ellipsis div:nth-child(2) {
  display:none;
}
.lds-ellipsis div:nth-child(3) {
  display:none;
}
.lds-ellipsis div:nth-child(4) {
  display:none;
}

#ardeat {
  position:absolute;
  width:50%;
  height:15%;
  left:0.5em;
  top:0;
}
#citat {
  position:absolute;
  display:block;
  margin:0 auto;
  display:flex;
}
#citat1 {
  display:none;
}
#click {
  left:62%;
  top:55%;
  display:block;
}
#click1 {
  display:none;
}
.locale-changer1 {
  display:none;
}
.locale-changer {
  font-size:10px;
  left:63%;
  top:13.9%;
  display:none;

}
#buton334 {
  display:block;
  position:absolute;
  font-size:32px;
  top:0;
  right:0;
  margin-right:0.5em;
  margin-top:0.2em;
}
#lang {
  font-size:6.3px;
  display:block;
  left:9em; 
  top:9.3%;
}
#lang1 {
  display:none;
}

#registered {
  top:11%;
  left:11%;
  font-size:10px;
  display:block;
  color:white;
}
#registered1 {
  display:none;
}
#buton333 {
  display:none;
}
#moto {
  font-size:12px;
  top:20%;
  display:none;
}
nav a {
  position:relative;
  display:grid;
  grid-gap:0px;
  font-size:12px;
  top:-1em;
  width:5em;
  border:none;
  padding:7px;
  margin-left:-2.6em;
  background-color:none;
  box-shadow:none;
}
#one {
  top:1.6em;
  
}
#two {
  top:-0.4em;
}
#three {
  top:-2.4em;
}
#four {
  top:-4.5em;
}
#five {
  top:-6.6em;
}
#six {
  top:-8.65em;
}
nav a.router-link-exact-active {
 background:#0D6EFD;
color:white;
border:none;
box-shadow:none;
transition:none;
}

#ardeat1 {
  width:130px;
  left:34%;
  height:40px;
  display:none;
}
#select {
  display:block;

}

#privacy {
  font-size:6px;
}
#terms {
  font-size:6px;
}
#pfooter {
  font-size:5px;
}



}
@media (min-width:400px) and (max-width:440px) {
  #citat {
    display:none;
    
  }
  #nav1 {
    display:block;
  }
  #nav {
    display:none;
  }
  #citat2 {
    display:block;
  }
  #buton334 {
    display:block;

  }
  #buton335 {
    display:none;
  }
  .lds-ellipsis div {
  display:none;
}
.lds-ellipsis div:nth-child(1) {
  display:none;
}
.lds-ellipsis div:nth-child(2) {
  display:none;
}
.lds-ellipsis div:nth-child(3) {
  display:none;
}
.lds-ellipsis div:nth-child(4) {
  display:none;
}
#citat {
  margin-left:8em;
}
} 
@media (min-width:429px) and (max-width:499px) {
  #nav {
  height:50px;
  display:none;
}
#nav1 {
  display:block;
}
#app {
  height:10px;
}
  #front {
  display:none;
}
#front1 {
  display:block;
}s
.lds-ellipsis  {
  top:-10em;
}
.lds-ellipsis div:nth-child(1) {
  display:none;
}
.lds-ellipsis div:nth-child(2) {
  display:none;
}
.lds-ellipsis div:nth-child(3) {
  display:none;
}
.lds-ellipsis div:nth-child(4) {
  display:none;
}

#ardeat {
  position:absolute;
  width:50%;
  height:15%;
  left:0.5em;
  top:0;
}
#citat {
  position:absolute;
  display:block;
  margin:0 auto;
  display:flex;
}
#citat1 {
  display:none;
}
#click {
  left:62%;
  top:55%;
  display:block;
}
#click1 {
  display:none;
}
.locale-changer1 {
  display:none;
}
.locale-changer {
  font-size:10px;
  left:63%;
  top:13.9%;
  display:none;
}
#buton334 {
  display:block;
  position:absolute;
  font-size:32px;
  top:0;
  right:0;
  margin-right:0.4em;
  margin-top:0.2em;
}
#lang {
  font-size:6.3px;
  display:block;
  left:9em; 
  top:9.3%;
}
#lang1 {
  display:none;
}

#registered {
  top:11%;
  left:11%;
  font-size:10px;
  display:none;
  color:white;
}
#registered1 {
  display:none;
}
#buton333 {
  display:none;
}
#moto {
  font-size:12px;
  top:20%;
  display:none;
}
nav a {
  position:relative;
  display:grid;
  grid-gap:0px;
  font-size:12px;
  top:-1em;
  width:5em;
  border:none;
  padding:7px;
  margin-left:-2.6em;
  background-color:none;
  box-shadow:none;
}
#one {
  top:1.6em;
  
}
#two {
  top:-0.4em;
}
#three {
  top:-2.4em;
}
#four {
  top:-4.5em;
}
#five {
  top:-6.6em;
}
#six {
  top:-8.65em;
}
nav a.router-link-exact-active {
 background:#0D6EFD;
color:white;
border:none;
box-shadow:none;
transition:none;
}

#ardeat1 {
  width:130px;
  left:34%;
  height:40px;
  display:none;
}
#select {
  display:block;

}

#privacy {
  font-size:6px;
}
#terms {
  font-size:6px;
}
#pfooter {
  font-size:5px;
}
 

}

@media (min-height:300px) and (max-height:349px) and (min-width:300px) and (max-width:349px) {
  #citat {
    position:relative;
    display:flex;
    margin:0 auto;
    font-size:15px;
    display:block;
    margin-top:8em;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:7.5em;
    margin-top:8.5em;
    display:block;
  }
  
  #buton335 {
    left:0;
    top:0;
    margin-left:3.7em;
    margin-top:12em;
  }
  #citat1 {
    display:none;
  }
  
  
  #click1 {
    top:0;
    left:0;
    margin-top:10em;
    display:none;
  }
  #registered {
    top:28.6%;
    margin-top:9.5em;
    margin-left:3.2em;
    display:none;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.7em;
  }
  #privacy {
    font-size:7px;
    left:1%;
  }
  #terms {
    font-size:7px;
    left:18%;
  }
  #ardeat1 {
    width:100px;
    height:30px;
    left:37%;
  }
  .lds-ellipsis {
    display:none;
  }
  .lds-ellipsis {
    display:none;
}
.lds-ellipsis div {
  display:none;
}
.lds-ellipsis div:nth-child(1) {
  display:none;
}
.lds-ellipsis div:nth-child(2) {
  display:none;
}
.lds-ellipsis div:nth-child(3) {
  display:none;
}
.lds-ellipsis div:nth-child(4) {
  display:none;
}
.policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}


}
@media (min-height:300px) and (max-height:349px) and (min-width:350px) and (max-width:399px) {
  #citat {
    position:relative;
    display:flex;
    margin:0 auto;
    font-size:15px;
    display:block;
    margin-top:7.5em;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:7.5em;
    margin-top:8.5em;
    display:block;
  }
  
  #buton335 {
    left:0;
    top:0;
    margin-left:3.7em;
    margin-top:12em;
  }
  #citat1 {
    display:none;
  }
  
  
  #click1 {
    top:0;
    left:0;
    margin-top:10em;
    display:none;
  }
  #registered {
    top:28.6%;
    margin-top:9.5em;
    margin-left:3.2em;
    display:none;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.7em;
  }
  #privacy {
    font-size:7px;
    left:1%;
  }
  #terms {
    font-size:7px;
    left:18%;
  }
  #ardeat1 {
    width:100px;
    height:30px;
    left:37%;
  }
  .lds-ellipsis {
    display:none;
  }
  .lds-ellipsis {
    display:none;
}
.lds-ellipsis div {
  display:none;
}
.lds-ellipsis div:nth-child(1) {
  display:none;
}
.lds-ellipsis div:nth-child(2) {
  display:none;
}
.lds-ellipsis div:nth-child(3) {
  display:none;
}
.lds-ellipsis div:nth-child(4) {
  display:none;
}
.policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
}
@media (min-height:300px) and (max-height:349px) and (min-width:400px) and (max-width:449px) {
  #citat {
    position:relative;
    display:flex;
    margin:0 auto;
    font-size:17px;
    display:block;
    margin-top:6em;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:7.5em;
    margin-top:8.5em;
    display:block;
  }
  
  #buton335 {
    left:0;
    top:0;
    margin-left:3.7em;
    margin-top:12em;
  }
  #citat1 {
    display:none;
  }
  
  
  #click1 {
    top:0;
    left:0;
    margin-top:10em;
    display:none;
  }
  #registered {
    top:28.6%;
    margin-top:9.5em;
    margin-left:3.2em;
    display:none;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.7em;
  }
  #privacy {
    font-size:7px;
    left:1%;
  }
  #terms {
    font-size:7px;
    left:14%;
  }
  #ardeat1 {
    width:100px;
    height:30px;
    left:37%;
  }
  .lds-ellipsis {
    display:none;
  }
  .lds-ellipsis {
    display:none;
}
.lds-ellipsis div {
  display:none;
}
.lds-ellipsis div:nth-child(1) {
  display:none;
}
.lds-ellipsis div:nth-child(2) {
  display:none;
}
.lds-ellipsis div:nth-child(3) {
  display:none;
}
.lds-ellipsis div:nth-child(4) {
  display:none;
}
.policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
}
@media (min-height:300px) and (max-height:349px) and (min-width:450px) and (max-width:499px) {
  #citat {
    left:0;
    top:0;
    margin-left:10em;
    margin-top:8.5em;
    display:block;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:8.5em;
    margin-top:8.5em;
    display:block;
  }
  #citat1 {
    display:none;
  }
  
  #buton334 {
    right:0;
    top:0;
    font-size:30px;
    margin-left:2em;
    margin-top:0.2em;
  }
  #click {
    top:61.4%;
  }
  #registered {
    top:28.6%;
    margin-left:-.5em;
    display:none;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:28.2em;
    margin-top:8.8em;
  }
  #privacy {
    font-size:7px;
    left:1%;
  }
  #terms {
    font-size:7px;
    left:12.5%;
  }
  #ardeat {
    margin-top:0.3em;
   height:50px;
  }
  .lds-ellipsis {
    display:none;
  }
  .lds-ellipsis {
    display:none;
}
.lds-ellipsis div {
  display:none;
}
.lds-ellipsis div:nth-child(1) {
  display:none;
}
.lds-ellipsis div:nth-child(2) {
  display:none;
}
.lds-ellipsis div:nth-child(3) {
  display:none;
}
.lds-ellipsis div:nth-child(4) {
  display:none;
}
.policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}

}
@media (min-height:350px) and (max-height:399px) and (min-width:300px) and (max-width:349px) {
  #citat {
    position:relative;
    display:flex;
    margin:0 auto;
    font-size:15px;
    display:block;
    margin-top:8em;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:7.5em;
    margin-top:8.5em;
    display:block;
  }
  
  #buton335 {
    left:0;
    top:0;
    margin-left:3.7em;
    margin-top:12em;
  }
  #citat1 {
    display:none;
  }
  
  
  #click1 {
    top:0;
    left:0;
    margin-top:10em;
    display:none;
  }
  #registered {
    top:28.6%;
    margin-top:9.5em;
    margin-left:3.2em;
    display:none;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.7em;
  }
  #privacy {
    font-size:7px;
    left:1%;
  }
  #terms {
    font-size:7px;
    left:18%;
  }
  #ardeat {
    width:50%;
    height:45px;
    left:0;
    top:0;
    margin-left:1em;
    margin-top:0.6em;
  }
  .lds-ellipsis {
    display:none;
  }
  .lds-ellipsis {
    display:none;
}
.lds-ellipsis div {
  display:none;
}
.lds-ellipsis div:nth-child(1) {
  display:none;
}
.lds-ellipsis div:nth-child(2) {
  display:none;
}
.lds-ellipsis div:nth-child(3) {
  display:none;
}
.lds-ellipsis div:nth-child(4) {
  display:none;
}
.policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
}
@media (min-height:350px) and (max-height:399px) and (min-width:350px) and (max-width:399px) {
  #citat {
    position:relative;
    display:flex;
    margin:0 auto;
    font-size:17px;
    display:block;
    margin-top:8em;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:7.5em;
    margin-top:8.5em;
    display:block;
  }
  
  #buton335 {
    left:0;
    top:0;
    margin-left:3.7em;
    margin-top:12em;
  }
  #citat1 {
    display:none;
  }
  
  
  #click1 {
    top:0;
    left:0;
    margin-top:10em;
    display:none;
  }
  #registered {
    top:28.6%;
    margin-top:9.5em;
    margin-left:3.2em;
    display:none;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.7em;
  }
  #privacy {
    font-size:7px;
    left:1%;
  }
  #terms {
    font-size:7px;
    left:16%;
  }
  #ardeat {
    height:50px;
  }
  .lds-ellipsis {
    display:none;
  }
  .lds-ellipsis {
    display:none;
}
.lds-ellipsis div {
  display:none;
}
.lds-ellipsis div:nth-child(1) {
  display:none;
}
.lds-ellipsis div:nth-child(2) {
  display:none;
}
.lds-ellipsis div:nth-child(3) {
  display:none;
}
.lds-ellipsis div:nth-child(4) {
  display:none;
}
.policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#one {
  top:2em;
}
#two {
  top:0em;
}
#three {
  top:-2em;
}
#four {
  top:-4em;
}
#five {
  top:-6em;
}
#six {
  top:-8em;
}

}
@media (min-height:350px) and (max-height:399px) and (min-width:400px) and (max-width:449px) {
  #citat {
    position:relative;
    display:flex;
    margin:0 auto;
    font-size:18px;
    display:block;
    margin-top:7em;
    
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:7.5em;
    margin-top:8.5em;
    display:block;
  }
  
  #buton335 {
    left:0;
    top:0;
    margin-left:3.7em;
    margin-top:12em;
  }
  #citat1 {
    display:none;
  }
  
  
  #click1 {
    top:0;
    left:0;
    margin-top:10em;
    display:none;
  }
  #registered {
    top:28.6%;
    margin-top:9.5em;
    margin-left:3.2em;
    display:none;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.7em;
  }
  #privacy {
    font-size:7px;
    left:1%;
  }
  #terms {
    font-size:7px;
    left:14%;
  }
  #ardeat1 {
    width:100px;
    height:30px;
    left:37%;
  }
  .lds-ellipsis {
    display:none;
  }
  .lds-ellipsis {
    display:none;
}
.lds-ellipsis div {
  display:none;
}
.lds-ellipsis div:nth-child(1) {
  display:none;
}
.lds-ellipsis div:nth-child(2) {
  display:none;
}
.lds-ellipsis div:nth-child(3) {
  display:none;
}
.lds-ellipsis div:nth-child(4) {
  display:none;
}
.policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}

#one {
  top:3em;
}
#two {
  top:1em;
}
#three {
  top:-1em;
}
#four {
  top:-3em;
}
#five {
  top:-5em;
}
#six {
  top:-7em;
}
}
@media (min-height:350px) and (max-height:399px) and (min-width:450px) and (max-width:499px) {
  #citat {
    position:relative;
    display:flex;
    margin:0 auto;
    font-size:18px;
    display:block;
    margin-top:7em;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:7.5em;
    margin-top:8.5em;
    display:block;
  }
  
  #buton335 {
    left:0;
    top:0;
    margin-left:3.7em;
    margin-top:12em;
  }
  #citat1 {
    display:none;
  }
  
  
  #click1 {
    top:0;
    left:0;
    margin-top:10em;
    display:none;
  }
  #registered {
    top:28.6%;
    margin-top:9.5em;
    margin-left:3.2em;
    display:none;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.7em;
  }
  #privacy {
    font-size:7px;
    left:1%;
  }
  #terms {
    font-size:7px;
    left:14%;
  }
  #ardeat1 {
    width:100px;
    height:30px;
    left:37%;
  }
  .lds-ellipsis {
    display:none;
  }
  .lds-ellipsis {
    display:none;
}
.lds-ellipsis div {
  display:none;
}
.lds-ellipsis div:nth-child(1) {
  display:none;
}
.lds-ellipsis div:nth-child(2) {
  display:none;
}
.lds-ellipsis div:nth-child(3) {
  display:none;
}
.lds-ellipsis div:nth-child(4) {
  display:none;
}
.policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}

#one {
  top:3em;
}
#two {
  top:1em;
}
#three {
  top:-1em;
}
#four {
  top:-3em;
}
#five {
  top:-5em;
}
#six {
  top:-7em;
}
}
@media (min-height:400px) and (max-height:449px) and (min-width:300px) and (max-width:349px) {
  #citat {
    right: 0;
top: 0;
margin-left:5.8em;
margin-top: 8.5em;  

  }
  #registered {
    left:0;
    top:0;
    margin-left:3.6em;
    margin-top:9.6em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:7.3em;
    margin-top:8.5em;
    display:none;
  }
  
  
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.65em;
  }
  #nav {
    height:5em;
  }
  #buton334 {
    right:0;
    top:0;
  }
  #privacy {
    font-size:7px;
  }
  #terms {
    font-size:7px;
    margin-left:-0.5em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:60%;
  height:60px;
}
#one {
top:3em;
}
#two {
  top:0.97em;
}
#three {
top:-1em;
}
#four {
top:-3em;
}
#five {
top:-5em;
}
#six {
top:-7em;
}
}
@media (min-height:400px) and (max-height:449px) and (min-width:350px) and (max-width:399px) {
  #citat {
    right: 0;
top: 0;
margin-left:7em;
margin-top: 8.5em;  

  }
  #registered {
    left:0;
    top:0;
    margin-left:3.6em;
    margin-top:9.6em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:7.3em;
    margin-top:8.5em;
    display:none;
  }
  
  
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.65em;
  }
  #nav {
    height:5em;
  }
  #buton334 {
    right:0;
    top:0;
  }
  #privacy {
    font-size:8px;
  }
  #terms {
    font-size:8px;
    margin-left:-0.5em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:60%;
  height:60px;
}
#one {
top:3em;
}
#two {
  top:0.97em;
}
#three {
top:-1em;
}
#four {
top:-3em;
}
#five {
top:-5em;
}
#six {
top:-7em;
}
}
@media (min-height:400px) and (max-height:449px) and (min-width:400px) and (max-width:449px) {
  #citat {
    right: 0;
top: 0;
margin-left:0.3em;
margin-top: 8.5em;   
display:block;

  }
  #registered {
    left:0;
    top:0;
    margin-left:3.6em;
    margin-top:9.6em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:7.3em;
    margin-top:8.5em;
    display:none;
  }
  
  
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.65em;
  }
  #nav {
    height:5em;
  }
  #buton334 {
    right:0;
    top:0;
  }
  #privacy {
    font-size:8px;
  }
  #terms {
    font-size:8px;
    margin-left:-0.5em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:60%;
  height:65px;
}
#one {
top:3em;
}
#two {
  top:0.97em;
}
#three {
top:-1em;
}
#four {
top:-3em;
}
#five {
top:-5em;
}
#six {
top:-7em;
}
}
@media (min-height:400px) and (max-height:449px) and (min-width:450px) and (max-width:499px) {
  #citat {
    right: 0;
top: 0;
margin-left:7.6em;
margin-top: 8.7em;  
font-size:20px;

  }
  #registered {
    left:0;
    top:0;
    margin-left:3.6em;
    margin-top:9.6em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:7.3em;
    margin-top:8.5em;
    display:none;
  }
  
  
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.65em;
  }
  #nav {
    height:5em;
  }
  #buton334 {
    right:0;
    top:0;
  }
  #privacy {
    font-size:8px;
  }
  #terms {
    font-size:8px;
    margin-left:-0.5em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:62%;
  height:74px;
}
#one {
top:4em;
}
#two {
  top:1.97em;
}
#three {
top:0em;
}
#four {
top:-2em;
}
#five {
top:-4em;
}
#six {
top:-6em;
}
}
@media (min-height:450px) and (max-height:499px) and (min-width:300px) and (max-width:349px) {
  
  #citat {
    left:0;
    top:0;
    margin-left:5.5em;
    margin-top:10.5em;
    display:block;
  }
  #ardeat {
    width:60%;
  }
  #citat1 {
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:8em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:10.7em;
    margin-top:15em;
  }
  
  #buton334 {
    right:0;
    top:0;
    margin-left:7.5em;
    margin-top:0.2em;
  }
  #click {
    top:61.4%;
  }
  #registered {
    margin-top:9.5em;
    margin-left:3.4em;
    display:none;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:22.4em;
    margin-top:9.5em;
  }
  #privacy {
    font-size:8px;
    left:1%;
  }
  #terms {
    font-size:8px;
    left:21%;
  }
  #ardeat1 {
    width:100px;
    height:30px;
    left:37%;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#one {
 top:3.5em;
}
#two {
top:1.5em;
}
#three {
top:-0.5em;
}
#four {
top:-2.5em;
}
#five {
top:-4.5em;
}
#six {
top:-6.5em;
}
}
@media (min-height:450px) and (max-height:499px) and (min-width:350px) and (max-width:399px) {
  
  #citat {
    right:0;
    top:0;
    margin-left:-0.4em;
    margin-top:10.5em;
    display:block;
  }
  #ardeat {
    width:60%;
  }
  #citat1 {
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:8em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:10.7em;
    margin-top:15em;
  }
  
  #buton334 {
    right:0;
    top:0;
    margin-left:7.5em;
    margin-top:0.2em;
  }
  #click {
    top:61.4%;
  }
  #registered {
    margin-top:9.5em;
    margin-left:3.4em;
    display:none;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:22.4em;
    margin-top:9.5em;
  }
  #privacy {
    font-size:9px;
    left:1%;
  }
  #terms {
    font-size:9px;
    left:19%;
  }
  #ardeat1 {
    width:100px;
    height:30px;
    left:37%;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#one {
 top:3.5em;
}
#two {
top:1.5em;
}
#three {
top:-0.5em;
}
#four {
top:-2.5em;
}
#five {
top:-4.5em;
}
#six {
top:-6.5em;
}
}
@media (min-height:450px) and (max-height:499px) and (min-width:400px) and (max-width:449px) {
  
  #citat {
    left:0;
    top:0;
    margin-left:8em;
    margin-top:10.5em;
    display:block;
  }
  #citat1 {
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:8em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:15em;
  }
  #ardeat {
    width:70%;
    height:70px;
  }
  #buton334 {
    right:0;
    top:0;
    display:block;
  }
  #click {
    top:61.4%;
  }
  #registered {
    margin-top:3.5em;
    margin-left:-1em;
    display:none;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.9em;
    margin-top:8.5em;
  }
  #privacy {
    font-size:8.5px;
    left:1%;
  }
  #terms {
    font-size:8.5px;
    left:17%;
  }
  #ardeat1 {
    width:100px;
    height:30px;
    left:37%;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#one {
top:4em;
}
#two {
top:1.9em;
}
#three {
top:-0.15em;
}
#four {
top:-2.16em;
}
#five {
top:-4.16em;
}
#six {
top:-6.2em;
}
}
@media (min-height:450px) and (max-height:499px) and (min-width:450px) and (max-width:499px) {
  
  #citat {
    left:0;
    top:0;
    margin-left:10em;
    margin-top:10.5em;
    display:block;
  }
  #citat1 {
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:8em;
    margin-top:10.5em;
    display:block;
  }
  
  
  #buton334 {
    right:0;
    top:0;
    
  }
  #click {
    top:61.4%;
  }
  #registered {
    margin-top:3.5em;
    margin-left:-1em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:28.3em;
    margin-top:8.7em;
  }
  #privacy {
    font-size:9px;
    left:1%;
  }
  #terms {
    font-size:9px;
    left:16%;
  }
  #ardeat1 {
    width:100px;
    height:30px;
    left:37%;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#one {
top:4em;
}
#two {
top:2em;
}
#three {
top:-0.1em;
}
#four {
top:-2.07em;
}
#five {
top:-4.07em;
}
#six {
top:-6.05em;
}
#ardeat {
  width:64%;
  height:74px;
}
}
@media (min-height:500px) and (max-height:549px) and (min-width:300px) and (max-width:349px) {
  #citat {
    left:0;
    top:0;
    margin-left:6em;
    margin-top:10em;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:8em;
    margin-top:10.5em;
    display:block;
  }
  #citat {
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  #buton334 {
    right:0;
    top:0;
    margin-left:0em;
    margin-top:0em;
    font-size:32px;
  }
  #click {
    top:20.7em;
  }
  #registered {
    margin-top:9.5em;
    margin-left:3.4em;
    display:none;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:22.5em;
    margin-top:9.4em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#privacy {
font-size:9px;
}
#terms {
  margin-left:-0.5em;
font-size:9px;
}
#ardeat {
  width:63%;
  height:63px;
}
#one {
top:3.5em;
}
#two {
top:1.5em;
}
#three {
top:-0.6em;
}
#four {
top:-2.6em;
}
#five {
top:-4.6em;
}
#six {
top:-6.64em;
}
}
@media (min-height:500px) and (max-height:549px) and (min-width:350px) and (max-width:399px) {
  #citat {
    left:0;
    top:0;
    margin-left:7em;
    margin-top:10em;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:8em;
    margin-top:10.5em;
    display:block;
  }
  #citat {
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:9.7em;
    margin-top:16em;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:32px;
  }
  #click {
    top:20.7em;
  }
  #registered {
    margin-top:7.9em;
    margin-left:1.9em;
    display:none;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.3em;
    margin-top:8.9em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:60%;
  height:70px;
}
#privacy {
font-size:9px;
}
#terms {
  margin-left:-0.3em;
  font-size:9px;
}
#one {
  top:4em;
}
#two {
top:1.9em;
}
#three {
top:-0.1em;
}
#four {
top:-2.1em;
}
#five {
top:-4.1em;
}
#six {
top:-6.1em;
}
}
@media (min-height:500px) and (max-height:549px) and (min-width:400px) and (max-width:449px) {
  #citat {
    left:0;
    top:0;
    margin-left:8.4em;
    margin-top:10em;
  }
  #ardeat {
    width:60%;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:8em;
    margin-top:10.5em;
    display:block;
  }
  #citat {
    display:block;
  }
  #buton335 { 
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:32px;
    display:block;
  }
  #click {
    top:20.7em;
  }
  #privacy {
  font-size:9px;
  }
  #terms {
  font-size:9px;
  margin-left:-0.5em;
  }
  #registered {
    display:none;
    margin-top:3.1em;
    margin-left:-0.8em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.8em;
    margin-top:8.6em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#one {
top:4.5em;
}
#two {
top:2.5em;
}
#three {
top:0.45em;
}
#four {
top:-1.6em;
}
#five {
top:-3.6em;
}
#six {
top:-5.6em;
}
}
@media (min-height:500px) and (max-height:549px) and (min-width:450px) and (max-width:499px) {
  #citat {
    left:0;
    top:0;
    margin-left:10.4em;
    margin-top:10em;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:8em;
    margin-top:10.5em;
    display:block;
  }
  #citat {
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:32px;
  }
  #click {
    top:20.7em;
  }
  #registered {
    margin-top:3.1em;
    margin-left:-0.8em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:28.3em;
    margin-top:8.6em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:65%;
  height:79px;
}
#privacy {
font-size:10px;
}
#terms {
font-size:10px;
margin-left:-0.5em;
}
#one {
top:4.7em;
}
#two {
top:2.6em;
}
#three {
top:0.6em;
}
#four {
top:-1.4em;
}
#five {
top:-3.5em;
}
#six {
top:-5.5em;
}
}
@media (min-height:550px) and (max-height:599px) and (min-width:300px) and (max-width:349px) {
  #citat {
    right:0;
    top:0;
    margin-left:5.5em;
    margin-top:10em;
  }
  #buton334 {
    right:0;
    top:0;
    margin-top:0em;
    font-size:37px;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:6em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  #click {
    top:20.7em;
   
  }
  #registered {
    margin-top:9.4em;
    margin-left:3.5em;
    display:none;
  }
  #privacy {
    font-size:9px;
  }
  #terms {
    font-size:9px;
    margin-left:-0.3em;
  }
  
  .locale-changer {
    left:0;
    top:0;
    margin-left:22.7em;
    margin-top:9.4em;
  }
  #ardeat {
    width:65%;
    height:70px;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#one {
top:4em;
}
#two {
top:2em;
}
#three {
top:-0.1em;
}
#four {
top:-2.2em;
}
#five {
top:-4.2em;
}
#six {
top:-6.2em;
}
}

@media (min-height:550px) and (max-height:599px) and (min-width:350px) and (max-width:399px) {
  #citat {
    left:0;
    top:0;
    margin-left:7em;
    margin-top:10em;
  }
  #buton334 {
    right:0;
    top:0;
    margin-top:0em;
    font-size:37px;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5.8em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  #ardeat {
    width:64%;
    height:70px;
  }
  #click {
    top:20.7em;
   
  }
  #registered {
    margin-top:8em;
    margin-left:1.9em;
    display:none;
  }
  
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.6em;
    margin-top:8.9em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#privacy {
  font-size:9.5px;
}
#terms {
  margin-left:-0.3em;
  font-size:9.5px;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#one {
top:4em;
}
#two {
top:2em;
}
#three {
top:0em;
}
#four {
top:-2em;
}
#five {
top:-4em;
}
#six {
top:-6em;
}
}
@media (min-height:550px) and (max-height:599px) and (min-width:400px) and (max-width:449px) {
  #citat {
    left:0;
    top:0;
    display:block;
    margin-left:8.5em;
    margin-top:11em;
  }
  #buton334 {
    right:0;
    top:0;
    margin-top:0em;
    font-size:37px;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5.8em;
    margin-top:10.5em;
    display:block;
  }
  #privacy {
    font-size:10px;
  }
  #terms {
    font-size:10px;
    margin-left:-0.4em;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  #click {
    top:20.7em;
   
  }
  #registered {
    margin-top:2.5em;
    margin-left:-0.7em;
    display:none;
    
  }
  
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.8em;
    margin-top:8.5em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:63%;
  height:77px;
}
#one {
top:5em;
}
#two {
top:3em;
}
#three {
top:1em;
}
#four {
top:-1em;
}
#five {
  top:-3em;
}
#six {
  top:-5em;
}
}
@media (min-height:550px) and (max-height:599px) and (min-width:450px) and (max-width:499px) {
  #citat {
    left:0;
    top:0;
    font-size:17px;
    display:block;
    margin-left:9em;
    margin-top:10em;
  }
  #buton334 {
    right:0;
    top:0;
    margin-top:0em;
    font-size:37px;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5.8em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:9.7em;
    margin-top:16em;
    font-size:15px;
  }
  #click {
    top:20.7em;
   
  }
  #registered {
    margin-top:2em;
    margin-left:-0.7em;
    font-size:13px;
  }
  
  .locale-changer {
    left:0;
    top:0;
    margin-left:26em;
    margin-top:8.05em;
    font-size:11px;
  }
  
  #lang {
    margin-left:1.2em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
#privacy {
  font-size:11px;
}
#terms {
  font-size:11px;
  margin-left:-0.3em;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:67%;
  height:80px;
}
#one {
top:5em;
}
#two {
top:3em;
}
#three {
top:1em;
}
#four {
top:-1em;
}
#five {
top:-3em;
}
#six {
top:-5.1em;
}
}
@media (min-height:600px) and (max-height:649px) and (min-width:300px) and (max-width:349px) {
  #registered {
    margin-top:9.2em;
    margin-left:3.4em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.2em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:6em;
    margin-top:10em;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:0;
  }
  #privacy {
    font-size:10px;
  }
  #terms {
    font-size:10px;
    margin-left:-0.7em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:63%;
  height:72px;
}
#one {
top:4em;
}
#two {
top:1.9em;
}
#three {
top:-0.1em;
}
#four {
top:-2.1em;
}
#five {
  top:-4.1em;
}
#six {
  top:-6.1em;
}
}
@media (min-height:600px) and (max-height:649px) and (min-width:350px) and (max-width:399px) {
  #registered {
    margin-top:8.2em;
    margin-left:1.9em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.4em;
    margin-top:9.2em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:7em;
    margin-top:10em;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:0;
  }
  #privacy {
    font-size:10.5px;
  }
  #terms {
    font-size:10.5px;
    margin-left:-0.5em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:64%;
  height:74px;
}
#one {
top:4.5em;
}
#two {
top:2.4em;
}
#three {
top:0.4em;
}
#four {
  top:-1.7em;
}
#five {
  top:-3.7em;
}
#six {
  top:-5.8em;
}
}
@media (min-height:600px) and (max-height:649px) and (min-width:400px) and (max-width:449px) {
  #registered {
    margin-top:1.7em;
    margin-left:-0.7em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:11.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  #ardeat {
   width:64%;
   height:81px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:0;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.9em;
    margin-top:8.4em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:8.5em;
    margin-top:11em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:9.2em;
    margin-top:20em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#privacy {
  font-size:11px;
}
#terms {
  font-size:11px;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#privacy {
  font-size:11px;
}
#terms {
  font-size:11px;
}
#one {
top:5em;
}
#two {
  top:3em;
}
#three {
  top:1em;
}
#four {
  top:-1em;
}
#five {
  top:-3em;
}
#six {
  top:-5em;
}
}
@media (min-height:600px) and (max-height:649px) and (min-width:450px) and (max-width:499px) {
  #registered {
    margin-top:1.5em;
    margin-left:-0.7em;
    font-size:12px;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:28.2em;
    margin-top:8.7em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:9.5em;
    margin-top:11em;
    display:block;
    font-size:17px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:0;
  }
  #ardeat {
    width:64%;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#privacy {
  font-size:12px;
}
#terms {
  font-size:12px;
  margin-left:-0.5em;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#one {
top:5em;
font-size:15px;
}
#two {
top:3.4em;
font-size:15px;
}
#three {
  top:1.8em;
  font-size:15px;
}
#four {
  top:0.2em;
  font-size:15px;
}
#five {
  top:-1.5em;
  font-size:15px;
}
#six {
  top:-3.1em;
  font-size:15px;
}

}
@media (min-height:650px) and (max-height:699px) and (min-width:300px) and (max-width:349px) {
  #registered {
    margin-top:9.2em;
    margin-left:3.4em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.2em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:6em;
    margin-top:10em;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:-0.1em;
  }
  #privacy {
    font-size:10px;
  }
  #terms {
    font-size:10px;
    margin-left:-0.7em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:63%;
  height:72px;
}
#one {
top:4em;
}
#two {
top:1.9em;
}
#three {
top:-0.1em;
}
#four {
top:-2.1em;
}
#five {
  top:-4.1em;
}
#six {
  top:-6.1em;
}
}
@media (min-height:650px) and (max-height:699px) and (min-width:350px) and (max-width:399px) {
  #registered {
    margin-top:8.2em;
    margin-left:1.9em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.4em;
    margin-top:9.2em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:7em;
    margin-top:10em;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:-0.1em;
  }
  #privacy {
    font-size:10.5px;
  }
  #terms {
    font-size:10.5px;
    margin-left:-0.5em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:64%;
  height:74px;
}
#one {
top:4.5em;
}
#two {
top:2.4em;
}
#three {
top:0.4em;
}
#four {
  top:-1.7em;
}
#five {
  top:-3.7em;
}
#six {
  top:-5.8em;
}
}
@media (min-height:650px) and (max-height:699px) and (min-width:400px) and (max-width:449px) {
  #registered {
    margin-top:1.7em;
    margin-left:-0.7em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:11.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  #ardeat {
   width:64%;
   height:86px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:-0.05em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.9em;
    margin-top:8.4em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:8.5em;
    margin-top:11em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:9.2em;
    margin-top:20em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#privacy {
  font-size:11px;
}
#terms {
  font-size:11px;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#privacy {
  font-size:11px;
}
#terms {
  font-size:11px;
}
#one {
  margin-left:-2em;
top:4em;
font-size:15px;
}
#two {
  margin-left:-2em;
  top:2.3em;
  font-size:15px;
}
#three {
  margin-left:-2em;
  top:0.7em;
  font-size:15px;
}
#four {
  margin-left:-2em;
  top:-1em;
  font-size:15px;
}
#five {
  margin-left:-2em;
  top:-2.6em;
  font-size:15px;
}
#six {
  margin-left:-2em;
  top:-4.2em;
  font-size:15px;
}
}
@media (min-height:650px) and (max-height:699px) and (min-width:450px) and (max-width:499px) {
  #registered {
    margin-top:1.5em;
    margin-left:-0.7em;
    font-size:12px;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:28.2em;
    margin-top:8.7em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:9.5em;
    margin-top:11em;
    display:block;
    font-size:17px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:-0.05em;
  }
  #ardeat {
    width:68%;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#privacy {
  font-size:12px;
}
#terms {
  font-size:12px;
  margin-left:-0.5em;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#one {
  margin-left:-2em;
top:5em;
font-size:15px;
}
#two {
  margin-left:-2em;
  top:3.3em;
  font-size:15px;
}
#three {
  margin-left:-2em;
  top:1.7em;
  font-size:15px;
}
#four {
  margin-left:-2em;
  top:0em;
  font-size:15px;
}
#five {
  margin-left:-2em;
  top:-1.6em;
  font-size:15px;
}
#six {
  margin-left:-2em;
  top:-3.2em;
  font-size:15px;
}
}

@media (min-height:700px) and (max-height:749px) and (min-width:300px) and (max-width:349px) {
  #registered {
    margin-top:9.2em;
    margin-left:3.4em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.2em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:6em;
    margin-top:10em;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:-0.15em;
  }
  #privacy {
    font-size:11px;
  }
  #terms {
    font-size:11px;
    margin-left:-0.7em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:66%;
  height:80px;
}
#one {
top:4.3em;
}
#two {
top:2.2em;
}
#three {
top:0.2em;
}
#four {
top:-1.8em;
}
#five {
  top:-3.8em;
}
#six {
  top:-5.8em;
}
}
@media (min-height:700px) and (max-height:749px) and (min-width:350px) and (max-width:399px) {
  #registered {
    margin-top:8.2em;
    margin-left:1.9em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.4em;
    margin-top:9.2em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:7em;
    margin-top:10em;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:-0.15em;
  }
  #privacy {
    font-size:11.5px;
  }
  #terms {
    font-size:11.5px;
    margin-left:-0.5em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:68%;
  height:79px;
}
#one {
top:4.5em;
font-size:14px;
}
#two {
top:2.7em;
font-size:14px;
}
#three {
top:0.9em;
font-size:14px;
}
#four {
  top:-0.8em;
  font-size:14px;
}
#five {
  top:-2.6em;
  font-size:14px;
}
#six {
  top:-4.4em;
  font-size:14px;
}
}
@media (min-height:700px) and (max-height:749px) and (min-width:400px) and (max-width:449px) {
  #registered {
    margin-top:1.7em;
    margin-left:-0.7em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:11.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  #ardeat {
   width:67%;
   height:86px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:-0.15em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.9em;
    margin-top:8.4em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:8.5em;
    margin-top:11em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:9.2em;
    margin-top:20em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#privacy {
  font-size:15px;
}
#terms {
  font-size:15px;
  margin-left:-0.5em;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#privacy {
  font-size:11px;
}
#terms {
  font-size:11px;
}
#one {
  margin-left:-2em;
top:4em;
font-size:15px;
}
#two {
  margin-left:-2em;
  top:2.3em;
  font-size:15px;
}
#three {
  margin-left:-2em;
  top:0.7em;
  font-size:15px;
}
#four {
  margin-left:-2em;
  top:-1em;
  font-size:15px;
}
#five {
  margin-left:-2em;
  top:-2.6em;
  font-size:15px;
}
#six {
  margin-left:-2em;
  top:-4.2em;
  font-size:15px;
}
}
@media (min-height:700px) and (max-height:749px) and (min-width:450px) and (max-width:499px) {
  #registered {
    margin-top:1.5em;
    margin-left:-0.7em;
    font-size:12px;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:28.2em;
    margin-top:8.7em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:9.5em;
    margin-top:11em;
    display:block;
    font-size:17px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:-0.15em;
  }
  #ardeat {
    width:68%;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#privacy {
  font-size:14px;
}
#terms {
  font-size:14px;
  margin-left:-0.5em;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#one {
  margin-left:-2em;
top:5em;
font-size:15px;
}
#two {
  margin-left:-2em;
  top:3.3em;
  font-size:15px;
}
#three {
  margin-left:-2em;
  top:1.7em;
  font-size:15px;
}
#four {
  margin-left:-2em;
  top:0em;
  font-size:15px;
}
#five {
  margin-left:-2em;
  top:-1.6em;
  font-size:15px;
}
#six {
  margin-left:-2em;
  top:-3.2em;
  font-size:15px;
}
.lds-ellipsis {
  margin-left:-10em;
}
}


@media (min-height:750px) and (max-width:800px) and (min-width:300px) and (max-width:349px) {
  #registered {
    margin-top:9.2em;
    margin-left:3.4em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.2em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:6em;
    margin-top:10em;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:-0.26em;
  }
  #privacy {
    font-size:12px;
  }
  #terms {
    font-size:12px;
    margin-left:-0.7em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:66%;
  height:80px;
}
#one {
top:4.3em;
}
#two {
top:2.2em;
}
#three {
top:0.2em;
}
#four {
top:-1.8em;
}
#five {
  top:-3.8em;
}
#six {
  top:-5.8em;
}
}
@media (min-height:750px) and (max-width:800px) and (min-width:350px) and (max-width:399px) {
  #registered {
    margin-top:8.2em;
    margin-left:1.9em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.4em;
    margin-top:9.2em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:7em;
    margin-top:10em;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:-0.26em;
  }
  #privacy {
    font-size:12.5px;
  }
  #terms {
    font-size:12.5px;
    margin-left:-0.5em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:68%;
  height:79px;
}
#one {
top:4.5em;
font-size:14px;
}
#two {
top:2.7em;
font-size:14px;
}
#three {
top:0.9em;
font-size:14px;
}
#four {
  top:-0.8em;
  font-size:14px;
}
#five {
  top:-2.6em;
  font-size:14px;
}
#six {
  top:-4.4em;
  font-size:14px;
}
}
@media (min-height:750px) and (max-width:800px) and (min-width:400px) and (max-width:449px) {
  #registered {
    margin-top:1.7em;
    margin-left:-0.7em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:11.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  #ardeat {
   width:73%;
   height:93px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:-0.26em;
    display:block;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.9em;
    margin-top:8.4em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:8.5em;
    margin-top:11em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:9.2em;
    margin-top:20em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#privacy {
  font-size:15px;
}
#terms {
  font-size:15px;
  margin-left:-0.5em;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#privacy {
  font-size:13px;
}
#terms {
  font-size:13px;
}
#one {
  margin-left:-2em;
top:4em;
font-size:17px;
}
#two {
  margin-left:-2em;
  top:2.5em;
  font-size:17px;
}
#three {
  margin-left:-2em;
  top:1em;
  font-size:17px;
}
#four {
  margin-left:-2em;
  top:-0.4em;
  font-size:17px;
}
#five {
  margin-left:-2em;
  top:-1.9em;
  font-size:17px;
}
#six {
  margin-left:-2em;
  top:-3.4em;
  font-size:17px;
}
}
@media (min-height:750px) and (max-width:800px) and (min-width:450px) and (max-width:499px) {
  #registered {
    margin-top:1.5em;
    margin-left:-0.7em;
    font-size:12px;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:28.2em;
    margin-top:8.7em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:9.5em;
    margin-top:11em;
    display:block;
    font-size:17px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:40px;
    margin-top:-0.1em;
    display:block;
  }
  #ardeat {
    width:68%;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#privacy {
  font-size:14px;
}
#terms {
  font-size:14px;
  margin-left:-0.5em;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#one {
  margin-left:-2em;
top:5em;
font-size:17px;
}
#two {
  margin-left:-2em;
  top:3.5em;
  font-size:17px;
}
#three {
  margin-left:-2em;
  top:2em;
  font-size:17px;
}
#four {
  margin-left:-2em;
  top:0.5em;
  font-size:17px;
}
#five {
  margin-left:-2em;
  top:-1em;
  font-size:17px;
}
#six {
  margin-left:-2em;
  top:-2.5em;
  font-size:17px;
}
.lds-ellipsis {
  margin-left:-8em;
}
}
@media (min-height:800px) and (max-height:849px) and (min-width:300px) and (max-width:349px) {
  #registered {
    margin-top:9.2em;
    margin-left:3.4em;
    display:none;
  }
  
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.2em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:5.2em;
    margin-top:15em;
    font-size:17px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:-0.3em;
    display:block;
  }
  #privacy {
    font-size:12px;
  }
  #terms {
    font-size:12px;
    margin-left:-0.7em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:67%;
  height:86px;
}
#one {
top:4.3em;
font-size:14.5px;
}
#two {
top:2.6em;
font-size:14.5px;
}
#three {
top:0.9em;
font-size:14.5px;
}
#four {
top:-0.9em;
font-size:14.5px;
}
#five {
  top:-2.5em;
  font-size:14.5px;
}
#six {
  top:-4.2em;
  font-size:14.5px;
}
}
@media (min-height:800px) and (max-height:849px) and (min-width:350px) and (max-width:399px) {
  #registered {
    margin-top:8.2em;
    margin-left:1.9em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.4em;
    margin-top:9.2em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:6em;
    margin-top:14em;
    font-size:18px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:37px;
    margin-top:-0.3em;
    display:block;
  }
  #privacy {
    font-size:12.5px;
  }
  #terms {
    font-size:12.5px;
    margin-left:-0.5em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:68%;
  height:87px;
}
#one {
top:4.5em;
font-size:14px;
}
#two {
top:2.7em;
font-size:14px;
}
#three {
top:0.9em;
font-size:14px;
}
#four {
  top:-0.8em;
  font-size:14px;
}
#five {
  top:-2.6em;
  font-size:14px;
}
#six {
  top:-4.4em;
  font-size:14px;
}
}
@media (min-height:800px) and (max-height:849px) and (min-width:400px) and (max-width:449px) {
  #registered {
    margin-top:1.7em;
    margin-left:-0.7em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:11.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  #ardeat {
   width:73%;
   height:93px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:40px;
    margin-top:-0.25em;
    display:block;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.9em;
    margin-top:8.4em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:6.5em;
    margin-top:13em;
    display:block;
    font-size:20px;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:9.2em;
    margin-top:20em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#privacy {
  font-size:16px;
}
#terms {
  font-size:16px;
  margin-left:-0.5em;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#privacy {
  font-size:13px;
}
#terms {
  font-size:13px;
}
#one {
  margin-left:-2em;
top:4em;
font-size:17px;
}
#two {
  margin-left:-2em;
  top:2.5em;
  font-size:17px;
}
#three {
  margin-left:-2em;
  top:1em;
  font-size:17px;
}
#four {
  margin-left:-2em;
  top:-0.4em;
  font-size:17px;
}
#five {
  margin-left:-2em;
  top:-1.9em;
  font-size:17px;
}
#six {
  margin-left:-2em;
  top:-3.4em;
  font-size:17px;
}
}
@media (min-height:800px) and (max-height:849px) and (min-width:450px) and (max-width:499px) {
  #registered {
    margin-top:1.5em;
    margin-left:-0.7em;
    font-size:12px;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:28.2em;
    margin-top:8.7em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:6.3em;
    margin-top:14em;
    display:block;
    font-size:22px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:44px;
    margin-top:-0.15em;
    display:block;
  }
  #ardeat {
    width:68%;
    height:102px;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#privacy {
  font-size:14px;
}
#terms {
  font-size:14px;
  margin-left:-0.5em;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#one {
  margin-left:-2em;
top:5em;
font-size:17px;
}
#two {
  margin-left:-2em;
  top:3.5em;
  font-size:17px;
}
#three {
  margin-left:-2em;
  top:2em;
  font-size:17px;
}
#four {
  margin-left:-2em;
  top:0.5em;
  font-size:17px;
}
#five {
  margin-left:-2em;
  top:-1em;
  font-size:17px;
}
#six {
  margin-left:-2em;
  top:-2.5em;
  font-size:17px;
}
}
@media (min-height:850px) and (max-height:899px) and (min-width:300px) and (max-width:349px) {
  #registered {
    margin-top:9.2em;
    margin-left:3.4em;
    display:none;
  }
  
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.2em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:5.2em;
    margin-top:15em;
    font-size:17px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:35px;
    margin-top:-0.43em;
    display:block;
  }
  #privacy {
    font-size:12px;
  }
  #terms {
    font-size:12px;
    margin-left:-0.7em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:67%;
  height:86px;
}
#one {
top:4.3em;
font-size:14.5px;
}
#two {
top:2.6em;
font-size:14.5px;
}
#three {
top:0.9em;
font-size:14.5px;
}
#four {
top:-0.9em;
font-size:14.5px;
}
#five {
  top:-2.5em;
  font-size:14.5px;
}
#six {
  top:-4.2em;
  font-size:14.5px;
}
}
@media (min-height:850px) and (max-height:899px) and (min-width:350px) and (max-width:399px) {
  #registered {
    margin-top:8.2em;
    margin-left:1.9em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.4em;
    margin-top:9.2em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:6em;
    margin-top:14em;
    font-size:18px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:35px;
    margin-top:-0.43em;
    display:block;
  }
  #privacy {
    font-size:12.5px;
  }
  #terms {
    font-size:12.5px;
    margin-left:-0.5em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:68%;
  height:87px;
}
#one {
top:4.5em;
font-size:14px;
}
#two {
top:2.7em;
font-size:14px;
}
#three {
top:0.9em;
font-size:14px;
}
#four {
  top:-0.8em;
  font-size:14px;
}
#five {
  top:-2.6em;
  font-size:14px;
}
#six {
  top:-4.4em;
  font-size:14px;
}
}
@media (min-height:850px) and (max-height:899px) and (min-width:400px) and (max-width:449px) {
  #registered {
    margin-top:1.7em;
    margin-left:-0.7em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:11.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  #ardeat {
   width:73%;
   height:93px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:38px;
    margin-top:-0.33em;
    display:block;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.9em;
    margin-top:8.4em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:6.5em;
    margin-top:13em;
    display:block;
    font-size:20px;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:9.2em;
    margin-top:20em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#privacy {
  font-size:16px;
}
#terms {
  font-size:16px;
  margin-left:-0.5em;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#privacy {
  font-size:15px;
}
#terms {
  font-size:15px;
}
#one {
  margin-left:-2em;
top:4em;
font-size:17px;
}
#two {
  margin-left:-2em;
  top:2.5em;
  font-size:17px;
}
#three {
  margin-left:-2em;
  top:1em;
  font-size:17px;
}
#four {
  margin-left:-2em;
  top:-0.4em;
  font-size:17px;
}
#five {
  margin-left:-2em;
  top:-1.9em;
  font-size:17px;
}
#six {
  margin-left:-2em;
  top:-3.4em;
  font-size:17px;
}
  
}
@media (min-height:850px) and (max-height:899px) and (min-width:450px) and (max-width:499px) {
  #registered {
    margin-top:1.5em;
    margin-left:-0.7em;
    font-size:12px;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:28.2em;
    margin-top:8.7em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:6.3em;
    margin-top:14em;
    display:block;
    font-size:22px;
  }
  #buton334 {
    right:0;
    top:0;
    font-size:42px;
    margin-top:-0.26em;
  }
  #ardeat {
    width:72%;
    height:102px;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#privacy {
  font-size:15px;
}
#terms {
  font-size:15px;
  margin-left:-0.5em;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#one {
  margin-left:-2em;
top:5em;
font-size:18px;
}
#two {
  margin-left:-2em;
  top:3.6em;
  font-size:18px;
}
#three {
  margin-left:-2em;
  top:2.2em;
  font-size:18px;
}
#four {
  margin-left:-2em;
  top:0.8em;
  font-size:18px;
}
#five {
  margin-left:-2em;
  top:-0.5em;
  font-size:18px;
}
#six {
  margin-left:-2em;
  top:-1.9em;
  font-size:18px;
}
}
@media (min-height:900px) and (max-height:949px) and (min-width:300px) and (max-width:349px) {
  #registered {
    margin-top:9.2em;
    margin-left:3.4em;
    display:none;
  }
  
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23em;
    margin-top:9.2em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:5.2em;
    margin-top:15em;
    font-size:17px;
  }
  #buton334 {
    right:0;
    top:0;
    margin-top:-0.5em;
    font-size:37px;
  }
  #privacy {
    font-size:12px;
  }
  #terms {
    font-size:12px;
    margin-left:-0.7em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:67%;
  height:86px;
}
#one {
top:4.3em;
font-size:14.5px;
}
#two {
top:2.6em;
font-size:14.5px;
}
#three {
top:0.9em;
font-size:14.5px;
}
#four {
top:-0.9em;
font-size:14.5px;
}
#five {
  top:-2.5em;
  font-size:14.5px;
}
#six {
  top:-4.2em;
  font-size:14.5px;
}
}
@media (min-height:900px) and (max-height:949px) and (min-width:350px) and (max-width:399px) {
  #registered {
    margin-top:8.2em;
    margin-left:1.9em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.4em;
    margin-top:9.2em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:6em;
    margin-top:14em;
    font-size:18px;
  }
  #buton334 {
    right:0;
    top:0;
    margin-top:-0.5em;
    font-size:37px;
  }
  #privacy {
    font-size:13.5px;
  }
  #terms {
    font-size:13.5px;
    margin-left:-0.5em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#ardeat {
  width:68%;
  height:87px;
}
#one {
top:4.5em;
font-size:14px;
}
#two {
top:2.7em;
font-size:14px;
}
#three {
top:0.9em;
font-size:14px;
}
#four {
  top:-0.8em;
  font-size:14px;
}
#five {
  top:-2.6em;
  font-size:14px;
}
#six {
  top:-4.4em;
  font-size:14px;
}
}
@media (min-height:900px) and (max-height:949px) and (min-width:400px) and (max-width:449px) {
  #registered {
    margin-top:1.7em;
    margin-left:-0.7em;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:11.5em;
    display:block;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:8.7em;
    margin-top:16em;
  }
  #ardeat {
   width:73%;
   height:93px;
  }
  #buton334 {
    right:0;
    top:0;
    margin-top:-0.4em;
    font-size:41px;
    display:block;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:23.9em;
    margin-top:8.4em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:6.5em;
    margin-top:13em;
    display:block;
    font-size:20px;
  }
  #buton335 {
    left:0;
    top:0;
    margin-left:9.2em;
    margin-top:20em;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#privacy {
  font-size:16px;
}
#terms {
  font-size:16px;
  margin-left:-0.5em;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#privacy {
  font-size:15px;
}
#terms {
  font-size:15px;
}
#one {
  margin-left:-2em;
top:4em;
font-size:17px;
}
#two {
  margin-left:-2em;
  top:2.5em;
  font-size:17px;
}
#three {
  margin-left:-2em;
  top:1em;
  font-size:17px;
}
#four {
  margin-left:-2em;
  top:-0.4em;
  font-size:17px;
}
#five {
  margin-left:-2em;
  top:-1.9em;
  font-size:17px;
}
#six {
  margin-left:-2em;
  top:-3.4em;
  font-size:17px;
}
}
@media (min-height:900px) and (max-height:949px) and (min-width:450px) and (max-width:499px) {
  #registered {
    margin-top:1.5em;
    margin-left:-0.7em;
    font-size:12px;
    display:none;
  }
  #citat2 {
    left:0;
    top:0;
    margin-left:5em;
    margin-top:10.5em;
    display:block;
  }
  .locale-changer {
    left:0;
    top:0;
    margin-left:28.2em;
    margin-top:8.7em;
    display:none;
  }
  #citat {
    left:0;
    top:0;
    margin-left:6.3em;
    margin-top:14em;
    display:block;
    font-size:22px;
  }
  #buton334 {
    right:0;
    top:0;
    margin-top:-0.3em;
    font-size:42px;
    display:block;
  }
  #ardeat {
    width:72%;
    height:114px;
  }
  .policy {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#titlus {
  font-size:16px;
  position:relative;
  top:1em;
}
#span23 {
  font-size:15px;
}
#span19 {
  font-size:12px;
}
.policy .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:11px;
  top:-1em;
}
.terms {
  top:4.5em;
  height:50%;
  font-size:10px;
  z-index:99;
}
#privacy {
  font-size:15px;
}
#terms {
  font-size:15px;
  margin-left:-0.5em;
}
.terms .closebtn {
  font-size:23px;
  top:0em;
  left:0.2em;
}
#one {
  margin-left:-2em;
top:5em;
font-size:18px;
}
#two {
  margin-left:-2em;
  top:3.6em;
  font-size:18px;
}
#three {
  margin-left:-2em;
  top:2.2em;
  font-size:18px;
}
#four {
  margin-left:-2em;
  top:0.8em;
  font-size:18px;
}
#five {
  margin-left:-2em;
  top:-0.5em;
  font-size:18px;
}
#six {
  margin-left:-2em;
  top:-1.9em;
  font-size:18px;
}
}

@media (min-width:500px) and (max-width:599px) {
  nav a {
    font-size:5.3px;
    top:-7.7em;
    left:7.3%;
    border:0.2px solid white;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  
  #moto {
    font-size:12px;
    left:0;
    top:0;
    margin-top:2em;
    margin-left:13em;
  }
  #ardeat {
    width:110px;
    height:35px;
    left:0;
    margin-top:0.1em;
    margin-left:0.2em;
  }
  #registered1 {
    font-size:5px;
    left:0;
    top:0;
    margin-left:3em;
    margin-top:6.4em;
  }
  .locale-changer1 {
    font-size:4px;
    right:0;
    top:0;
    margin-right:6em;
    margin-top:2.8em;
  }
  #privacy {
    font-size:4.5px;
  }
  #terms {
    font-size:4.5px;
    
  }
  #lang1 {
    font-size:3px;
    height:3.3em;
    width:6em;
    top:-.6em; 
    
  }
  #citat1 {
    font-size:9.5px;
    left:0;
    top:0;
    margin-top:13em;
    margin-left:2.4em;
  }
  #click1 {
    font-size:5.5px;
    left:0;
    top:0;
    margin-top:24em;
    margin-left:14em;
  }
  #buton333 {
    font-size:5.2px;
    margin-left:8em;
    margin-top:7em;   
    left:0;
  }
  #ardeat1 {
    width:90px;
    height:27px;
    left:43%;
  }
  #pfooter {
    font-size:5px;
  }
  #textup {
    top:2em;
  }
  .policy {
  top:7.5em;
  height:50%;
  font-size:7px;
  z-index:99;
}
#titlus {
  font-size:14px;
  position:relative;
  top:0.1em;
}
#span23 {
  font-size:10px;
}
#span19 {
  font-size:7px;
}
.policy .closebtn {
  font-size:24px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:6px;
  padding:5px 5px;
  top:-0.5em;
}
.terms {
  top:7.5em;
  height:50%;
  font-size:7px;
  z-index:99;
}
.terms .closebtn {
  font-size:24px;
  top:0;
  left:0.2em;
}
#select1 {
  font-size:5px;
  margin-top:-0.4em;
}
#lang1 {
  width:2px;
  margin-left:5em;
  margin-top:0.3em;
}
.lds-ellipsis {
  top:-7em;
}

}

@media (min-width:600px) and (max-width:699px) {
  nav a {
    font-size:6.2px;
    top:-5.4em;
    left:7.4%;
    border:0.3px solid white;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  #moto {
    font-size:14.5px;
    left:0;
    top:0;
  }
  #ardeat {
    width:140px;
    height:45px;
    left:0;
    margin-top:0.25em;
  }
  #registered1 {
    font-size:6.5px;
    left:0;
    top:0;
    margin-left:2.3em;
    margin-top:6.4em;
  }
  .locale-changer1 {
    font-size:6px;
    right:0;
    top:0;
    margin-right:5.3em;
    margin-top:2.4em;
  }
  #privacy {
    font-size:6px;
  }
  #terms {
    font-size:6px;
    left:0;
    bottom:0;
    margin-left:8.4em;
    margin-bottom:0.34em;
  }
  #lang1 {
    margin-top:0.6em;
    font-size:3px;
    height:3.5em;

  }
  #citat1 {
    font-size:10.5px;
    left:0;
    top:0;
   margin-top:13em;
   margin-left:7.5em;
   display:block;
  }
  #citat {
    display:none;
  }
  #click {
    font-size:7px;
    top:5%;
    left:16%;
    display:block;
    z-index:99;
    display:none;
  }
  #click1 {
    font-size:7px;
    top:0;
    left:0;
    margin-top:23em;
    margin-left:14em;
    display:block;
    z-index:99;
    display:block;

  }
  #buton333 {
    font-size:6.5px;
    left:0;
    margin-left:8em;
    margin-top:11.8em;
  }
  #pfooter {
    font-size:6px;
  }
  #privacy {
    font-size:6.5px;
  }
  #terms {
    margin-bottom:0.25em;
    font-size:6.5px;
    
  }
  #lang1 {
    font-size:3px;
    height:3.3em;
    width:6em;
    top:-.6em; 
    
  }
  #citat1 {
    font-size:10px;
    left:0;
    top:0;
    margin-top:14em;
    margin-left:4em;
  }
  #click1 {
    font-size:7.5px;
    left:0;
    top:0;
    margin-top:23em;
    margin-left:13em;
  }
  
  #ardeat1 {
    width:100px;
    height:30px;
    left:44%;
  }
  #pfooter {
    font-size:5px;
  }
  #textup {
    top:2em;
  }
  .policy {
  top:7.5em;
  height:50%;
  font-size:6px;
  z-index:99;
}
#titlus {
  font-size:14px;
  position:relative;
  top:0.1em;
}
#span23 {
  font-size:10px;
}
#span19 {
  font-size:7px;
}
.policy .closebtn {
  font-size:24px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:7px;
  top:-0.5em;
}
.terms {
  top:7.5em;
  height:50%;
  font-size:6px;
  z-index:99;
}
.terms .closebtn {
  font-size:24px;
  top:0em;
  left:0.2em;
}
.lds-ellipsis {
  margin-top:-5em;
}
  
}
@media (min-width:700px) and (max-width:799px) {
  nav a {
    font-size:7.4px;
    top:-4.2em;
    left:7.2%;
    border:0.2px solid white;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  #moto {
    font-size:18px;
    left:0;
    top:0;
    margin-left:14em;
  }
  #ardeat {
    width:180px;
    height:55px;
    left:0;
    top:0;
    margin-top:0.3em;
  }
  #registered1 {
    font-size:9px;
    left:0;
    top:0;
    margin-left:1.3em;
  }
  .locale-changer1 {
    font-size:7px;
    right:0;
    top:0;
    margin-right:6em;
    margin-top:2.7em;
  }
  #privacy {
    font-size:9px;
  }
  #terms {
    font-size:9px;
  }
  
  #lang1 {
    font-size:5px;
    top:-0.2em;
  }
  #citat1 {
    font-size:14px;
    left:0;
    top:0;
    margin-top:14em;
    margin-left:2.6em;
  }
  #click1 {
    font-size:8.5px;
    top:0;
    left:0;
    margin-top:23.7em;
    margin-left:14.5em;
  }
  #buton333 {
    font-size:8px;
    left:0;
    margin-left:8.5em;
    margin-top:13em;
  }

  #ardeat1 {
    width:140px;
    height:40px;
  }
  #citat {
    display:none;
  }
  #pfooter {
    font-size:8px;
  }
  #textup {
    top:4em;
  }
  .policy {
  top:7.5em;
  height:50%;
  font-size:8px;
  z-index:99;
}
#titlus {
  font-size:21px;
  position:relative;
  top:0.1em;
}
#span23 {
  font-size:13px;
}
#span19 {
  font-size:10px;
}
.policy .closebtn {
  font-size:24px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:7px;
  padding:7px 7px;
  top:-0.5em;
}
.terms {
  top:7.5em;
  height:50%;
  font-size:8px;
  z-index:99;
}
.terms .closebtn {
  font-size:24px;
  top:0em;
  left:0.2em;
}
#select1 {
  margin-top:-0.3em;
}
#lang1 {
  font-size:6px;
  width:24px;
  margin-top:-0.4px;
}
.lds-ellipsis {
  margin-top:-5em;
}
  
}
@media (min-width:800px) and (max-width:899px) {
  #citat {
    display:none;
  }
  #textup {
    top:4em;
  }
  .policy {
  top:7.5em;
  height:50%;
  font-size:8px;
  z-index:99;
}
#titlus {
  font-size:21px;
  position:relative;
  top:0.1em;
}
#span23 {
  font-size:13px;
}
#span19 {
  font-size:10px;
}
.policy .closebtn {
  font-size:24px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:7px;
  padding:7px 7px;
  top:-0.5em;
}
.terms {
  top:7.5em;
  height:50%;
  font-size:8px;
  z-index:99;
}
.terms .closebtn {
  font-size:24px;
  top:0em;
  left:0.2em;
}

}
@media (min-width:900px) and (max-width:999px) {
  #citat {
    display:none;
  }
  #citat1 {
    display:block;
  }
  #terms {
    margin-left:0em;
  }
  #textup {
    top:4em;
  }
  .policy {
  top:7.5em;
  height:50%;
  font-size:9.5px;
  z-index:99;
}
#titlus {
  font-size:21px;
  position:relative;
  top:0.1em;
}
#span23 {
  font-size:14px;
}
#span19 {
  font-size:11px;
}
.policy .closebtn {
  font-size:24px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:7px;
  padding:7px 7px;
  top:-0.5em;
}
.terms {
  top:7.5em;
  height:50%;
  font-size:9.5px;
  z-index:99;
}
.terms .closebtn {
  font-size:24px;
  top:0em;
  left:0.2em;
}
#terms {
 left:8.5em;
}
}
@media (min-width:1000px) and (max-width:1099px) {
  #citat {
    display:none;
  }
  #citat1 {
    display:block;
  }
  #terms {
    left:1em;
  }
  #textup {
    top:4em;
  }
  .policy {
  top:7.5em;
  height:50%;
  font-size:12.5px;
  z-index:99;
}
#titlus {
  font-size:30px;
  position:relative;
  top:0.1em;
}
#span23 {
  font-size:17px;
}
#span19 {
  font-size:15px;
}
.policy .closebtn {
  font-size:30px;
  top:0em;
  left:0.2em;
}
.clozebtn {
  font-size:8px;
  padding:9px 9px;
  top:-0.5em;
}
.terms {
  top:7.5em;
  height:50%;
  font-size:12.5px;
  z-index:99;
}
.terms .closebtn {
  font-size:24px;
  top:0em;
  left:0.2em;
}
#terms {
 left:8.5em;
}
}
@media (min-width:1100px) and (max-width:1199px) {
  #citat {
    display:none;
  }
  #citat1 {
    display:block;
  }
  
}

@media (min-width:1300px) and (max-width:1399px) {
  nav a {
    font-size:15px;
    top:-.7em;
    left:6%;
  }
  #ardeat {
    left:0;
    top:0;
    width:300px;
    height:92px;
    margin-left:0.7em;
    margin-top:0.4em;
  }
  #privacy {
    font-size:15px;
    
  }
  #buton333 {
    left:0;
    margin-left:7em;
  }
  #citat1 {
    position:absolute;
    left:0;
    top:0;
    margin-top:13em;
    margin-left:3.9em;
    font-size:22px;
  }
  #click1 {
    margin-bottom:24.2em;
    margin-left:14em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  #registered1 {
    left:0;
    top:0;
    margin-top:5.7em;
    margin-left:1.4em;
    font-size:15px;
  }
  .locale-changer1 {
    font-size:15px;
    right:0;
    top:0;
  }
  #lang1 {
   margin-top:-0.1em;
  }
  
  #terms {
    font-size:15px;
    
  }
  #ardeat1 {
width:270px;
height:70px;
  }
  nav a {
    font-size:16px;
  }
  #select1 {
    margin-top:0em;
  }
}
@media (min-width:1600px) and (max-width:1699px) {
  #moto {
    margin-left:18em;
    margin-top:2.2em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
}


@media (min-width:1700px) and (max-width:1799px) {
  #moto {
    margin-left:14em;
    margin-top:1.9em;
    font-size:40px;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  nav a {
    top:-0.3em;
    font-size:22px;
  }
  .locale-changer1 {
    font-size:20px;
    margin-top:1.8em;
  }
  #lang1 {
    margin-top:0.3em;
  }

}
@media (min-width:1800px) and (max-width:1899px) {
  
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
}
@media (min-width:1900px) and (max-width:1999px) {
  #registered1 {
    top:6em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  .locale-changer1 {
    left:101em;  
  }
  #moto {
    top:7%;
    left:40%;
  }
}
@media (min-width:2200px) and (max-width:2299px) {
  #registered1 {
    top:6em;
  }
  #buton333 {
    left:8em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  #click1 {
    left:15em;
  }
  #moto {
    left:32em;
    top:2.5em;
  }
  .locale-changer1 {
    left:123.5em;
    top:2.2em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
}



@media (min-width:800px) and (max-width:899px) {
  #ardeat {
    width:170px;
    height:60px;
    left:0;
    top:0;
    margin-top:0.2em;
    margin-left:0.5em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  #registered1 {
    left:0;
    top:0;
    margin-left:1.2em;
    margin-top:5.9em;
    font-size:9px;
  }
  #buton333 {
    left:0;
    margin-top:14em;
    font-size:10px;
    margin-left:6.5em;

  }
  #click1 {
    left:0;
    margin-left:13.1em;
    margin-top:23.8em;
    font-size:10px;
    display:block;
  }
  #privacy {
    left:0;
    bottom:0;
    font-size:9px;
    margin-bottom:0.4em;
    margin-left:0.7em;
  }
  #terms {
    left:0;
    bottom:0;
    font-size:9px;
    margin-bottom:0.4em;
    margin-left:8em;
  }
  .locale-changer1 {
    right:0;
    top:0;
    margin-top:2.3em;
    font-size:8.5px;
    margin-left:1em;
    right:1.5em;
  }
   #lang1 {
    font-size:7px;
    margin-top:-0.1em;
   
   }
   #ardeat1 {
    width:150px;
    height:40px;
   }
   #pfooter {
    font-size:10px;
   }
   nav a {
    font-size:9px;
    top: -3.3em;
    left:4.3em;
   }
   #moto {
    font-size:21px;
    left:0;
    top:0;
    margin-left:13em;
    margin-top:1.8em;
   }
   #citat1 {
    position:absolute;
    left:0;
    top:0;
    font-size:14px;
    margin-top:15em;
    margin-left:2.9em;
   }
   #select1 {
    margin-top:-0.3em;
   }
  
}
@media (min-width:900px) and (max-width:999px) {
  nav a {
    font-size:10.5px;
    top:-2.6em;
    left:6em;
    height:2em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  .locale-changer1 {
    font-size:9px;
    right:0;
    margin-top:2.3em;
  }
  
  #lang1 {
    font-size:7px;
    margin-top:-0.1em;
  }
  #select1 {
    margin-top:-0.2em;
  }
  #privacy {
    font-size:10px;
  }
  #terms {
    font-size:10px;
  }
  #ardeat1 {
    width:160px;
    height:40px;
  }
  #pfooter {
    font-size:9px;
  }
  
  #ardeat {
    width:220px;
    height:70px;
    left:0;
    top:0;
    margin-top:0.2em;
    margin-left:0.6em;
  }
  #moto {
    font-size:22px;
    top:0;
    left:0;
    margin-left:15em;
    margin-top:1.8em;
  }
  #registered1 {
    font-size:11px;
    left:0;
    top:0;
    margin-top:5.7em;
  }
  #citat1 {
    font-size:15px;
    left:0;
    top:0;
    margin-left:3.7em;
    margin-top:12.2em;
  }
  #buton333 {
    font-size:11px;
    left:0;
    margin-left:8em;
  }
  #click1 {
    font-size:11px;
    top:0;
    top:0;
    margin-top:24.6em;
    margin-left:15em;
  }
}
@media (min-width:1000px) and (max-width:1099px) {
  nav a {
    font-size:12px;
    left:4.5%;
    top:-1.8em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  #ardeat {
    width:210px;
    height:70px;
    left:0;
    top:0;
    margin-left:0.7em;
  }
  #citat1 {
    font-size:16px;
    left:0;
    top:0;
    margin-left:3.4em;
    margin-top:14em;
  }
  #registered1 {
    font-size:11px;
    top:0;
    left:0;
    margin-top:6em;
    margin-left:1.8em;
  }
  #buton333 {
    font-size:12px;
    left:0;
    margin-left:6.6em;
  }
  #click1 {
    font-size:12px;
    margin-top:23.8em;
    margin-left:13.7em;
  }
  #moto {
    font-size:25px;
    left:0;
    top:0;
    margin-left:14em;
    margin-top:1.7em;
  }
  .locale-changer1 {
    right:0;
    margin-top:1.8em;
    font-size:12px;
  }
  #lang1 {
    font-size:9px;
  }
  #privacy {
    font-size:11.5px;
  }
  #terms {
    font-size:11.5px;
  }
  #pfooter {
    font-size:10px;
  }
  #ardeat1 {
    width:180px;
    height:50px;
    left:26em;
  }
}
@media (min-width:1100px) and (max-width:1199px) {
  nav a {
    font-size:13px;
    left:6.6%;
    top:-1.1em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  .locale-changer1 {
    top:0;
    right:0;
    margin-right:3.4em;
    font-size:13px;
  }
  #lang1 {
    font-size:10.5px;
  }
  #ardeat {
    width:266px;
    height:80px;
    left:.7%;
  }
  #registered1 {
    font-size:13.5px;
    top:0;
    left:0;
    margin-top:5.5em;
    margin-left:1.8em;
  }
  #citat1 {
    font-size:18px;
    left:0;
    top:0;
    margin-top:14em;
    margin-left:3.8em;
  }
  #ardeat1 {
      width:200px;
      height:60px;
      left:42%;
  }
  #privacy {
    font-size:13px;
  }
  #terms {
    font-size:13px;
  }
  #pfooter {
    font-size:11px;
  }
  #buton333 {
    font-size:14px;
    left:0;
    margin-left:7em;
  }
  #click1 {
    font-size:14.5px;
    left:0;
    margin-top:22em;
  }
  #moto {
    font-size:27px;
    left:0;
    top:0;
    margin-top:2em;
  }

}
@media (min-width:1200px) and (max-width:1299px) {
  nav a {
    font-size:15px;
    top:-.8em;
    left:7%;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  #ardeat {
    height:85px;
    left:0;
    top:0;
    margin-left:1em;
    width:270px;
  }
  #registered1 {
    font-size:13.3px;
    left:0;
    top:0;
    margin-left:2.3em;
    margin-top:6em;
  }
  #citat1 {
    font-size:19px;
    left:0;
    top:0;
    margin-top:13em;
    margin-left:3.8em;
  }
  #buton333 {
    font-size:15.3px;
    
  }
  #click1 {
    left:0;
    top:0;
    margin-top:21.4em;
  }
  #moto {
    font-size:30px;
    left:0;
    top:0;
    margin-left:14em;
    margin-top:1.9em;
  }
  
  #ardeat1 {
    width:230px;
    height:70px;
  }
  #privacy {
    font-size:14px;
  }
  #terms {
    font-size:14px;
  }
  #select1 {
    font-size:14px;
    
  }
  .locale-changer1 {
    right:0;
    top:0;
    margin-right:1.4em;
    margin-top:2.3em;
    width:20em;
    font-size:12px;
  }
}

@media (min-width:1400px) and (max-width:1499px) {
  nav a {
    left:5%;
    font-size:17px;
  }
}
#citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  left:0;
  top:0;
  margin-left:1em;
  margin-top:3em;
  width: 13px;
  height: 13px;
  z-index:-1;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
@media (min-width:1800px) and (max-width:1890px) {
  #moto {
    margin-left:22em;
  }
}
@media (min-width:1900px) and (max-width:1999px) {
  #ardeat {
    width:330px;
    height:110px;
    left:0;
    top:0;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  #registered1 {
    left:0;
    top:0;
    margin-top:6.3em;
  }
  #citat1 {
    left:0;
    top:0;
    margin-top:14em;
    margin-left:3.8em;
      }
      #buton333 {
        left:0;
        top:0;
        margin-top:21.2em;
      }
      #moto {
        left:0;
        top:0;
        margin-left:25em;
      }
}
@media (min-width:2000px) and (max-width:2099px) {
  #moto {
    margin-left:27em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
}
@media (min-width:2100px) and (max-width:2199px) {
  #moto {
    margin-left:27em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
}
@media (min-width:2200px) and (max-width:2299px) {
  #registered1 {
    left:0;
    top:0;
    margin-left:1.5em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  #buton333 {
    margin-left:0em;
  }
  #click1 {
    margin-left:0em;
  }
  #citat1 {
    margin-left:0.3em;
  }
  #moto {
    left:0;
    top:0;
    margin-left:30em;
  }
  .locale-changer1 {
    margin-top:0em;
  }

}
@media (min-width:2300px) and (max-width:2399px) {
  #moto {
    left:0;
    top:0;
    margin-left:32em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  #ardeat1 {
    left:67em;
  }
}
@media (min-width:2400px) and (max-width:2499px) {
  #moto {
    left:0;
    top:0;
    margin-left:32em;
  }
  #ardeat1 {
    left:67em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
}
@media (min-width:2500px) and (max-width:2599px) {
  #moto {
    left:0;
    top:0;
    margin-left:34em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
}
@media (min-width:2600px) and (max-width:2699px) {
  #moto {
    margin-left:36em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
}
@media (min-width:2700px) and (max-width:2799px) {
  #moto {
    margin-left:40em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
}
@media (min-width:2800px) and (max-width:2899px) {
  #moto {
    margin-left:40em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
}
@media (min-width:2900px) and (max-width:2999px) {
  #moto {
    margin-left:40em;
  
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
}
@media (min-width:3000px) and (max-width:3099px) {
  #moto {
    margin-left:45em;
  }
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
  #lang1 {
    height:2em;
  }
  #ardeat1 {
    margin-left:12em;
  }
}
@media (min-width:3100px) and (max-width:5100px) {
#moto {
margin-left:80em;
}
#citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
#ardeat1 {
  margin-left:26em;
}
.locale-changer1 {
  margin-right:6em;
}
#lang1 {
  height:2em;
}
}
@media (min-width:5400px) and (max-width:6100px) {
  #ardeat1 {
    margin-left:30em;
  } 
  #moto {
    margin-left:94em;
  }
}


@media (min-width:500px) and (max-width:6000px) {
  #citat2 {
  position:absolute;
 left:0;
 top:0;
 z-index:1;
 display:none;
}
}
</style>
